import { defineMessages } from 'react-intl';

export const GENERIC_ERROR_MESSAGES = {
    GET: 'Failed to fetch details.',
    CREATE_UPDATE_DELETE:
        'We couldn’t complete this action right now. Please try again or refresh the page if this persists.',
};

const Locale = defineMessages({
    ssoAppTitle: {
        id: 'sts-user-management-ui.ssoAppTitle',
        defaultMessage: 'User & Application Settings',
    },
    searchPlaceholder: {
        id: 'sts-user-management-ui.searchPlaceholder',
        defaultMessage: 'Search',
    },
    users: {
        id: 'sts-user-management-ui.users',
        defaultMessage: 'Users',
    },
    contentAssignment: {
        id: 'sts-user-management-ui.contentAssignment',
        defaultMessage: 'Content Assignment',
    },
    contentAssignedSuccessfully: {
        id: 'sts-user-management-ui.contentAssignedSuccessfully',
        defaultMessage: `Content assigned.`,
    },
    contentUnassignedSuccessfully: {
        id: 'sts-user-management-ui.contentUnassignedSuccessfully',
        defaultMessage: `Content unassigned.`,
    },
    contentAssignmentError: {
        id: 'sts-user-management-ui.contentAssignmentError',
        defaultMessage: `Unable to assign or unassign content right now. Please refresh the page and try again.`,
    },
    contentErrorMainTitle: {
        id: 'sts-user-management-ui.contentErrorMainTitle',
        defaultMessage: `Oops, there was a problem loading the items.`,
    },
    contentErrorSubTitle: {
        id: 'sts-user-management-ui.contentErrorSubTitle',
        defaultMessage: `Please refresh the page or contact our support team if you need assistance. Thank you!`,
    },
    contentComingSoonTitle: {
        id: 'sts-user-management-ui.contentComingSoonTitle',
        defaultMessage: `Exciting new content is on the way. Stay tuned for updates.`,
    },
    contentComingSoonSubtitle: {
        id: 'sts-user-management-ui.contentComingSoonSubtitle',
        defaultMessage: `We’re working on adding new content. Stay connected for upcoming updates.`,
    },
    contentDoDomainSelectedTitle: {
        id: 'sts-user-management-ui.contentDoDomainSelectedTitle',
        defaultMessage: `Select a domain`,
    },
    contentDoDomainSelectedSubtitle: {
        id: 'sts-user-management-ui.contentDoDomainSelectedSubtitle',
        defaultMessage: `Search for and select a domain from the menu to view its content.`,
    },
    contentNoDataTitle: {
        id: 'sts-user-management-ui.contentNoDataTitle',
        defaultMessage: `No content available to display.`,
    },
    contentNoDataSubtitle: {
        id: 'sts-user-management-ui.contentNoDataSubtitle',
        defaultMessage: `There is no content in this category or domain. Please select a different category.`,
    },
    contentSelectAllOnPage: {
        id: 'sts-user-management-ui.contentSelectAllOnPage',
        defaultMessage: 'Select all visible items on this page',
    },
    contentSelectAllInDataset: {
        id: 'sts-user-management-ui.contentSelectAllInDataset',
        defaultMessage: 'Select all items in the dataset',
    },
    contentSelectAllInDatasetAndNewlyAdded: {
        id: 'sts-user-management-ui.contentSelectAllInDatasetAndNewlyAdded',
        defaultMessage: 'Select all items in the dataset and auto-select new items',
    },
    emptyLabelText: {
        id: 'sts-user-management-ui.emptyLabelText',
        defaultMessage: `No results found`,
    },
    usersList: {
        id: 'sts-user-management-ui.usersList',
        defaultMessage: 'Users List',
    },
    assignUsers: {
        id: 'sts-user-management-ui.assignUsers',
        defaultMessage: 'Assign Users',
    },
    assignedUsers: {
        id: 'sts-user-management-ui.assignedUsers',
        defaultMessage: 'Assigned Users',
    },
    assignedUsersSubHeader: {
        id: 'sts-user-management-ui.assignedUsersSubHeader',
        defaultMessage:
            'Search and enter in a user or multiple users to assign as identity role that you would like to grant access to following applications below.',
    },
    advancedProduct: {
        id: 'sts-user-management-ui.advancedProduct',
        defaultMessage: 'Advanced',
    },
    addUserButton: {
        id: 'sts-user-management-ui.addUserButton',
        defaultMessage: 'INVITE A USER',
    },
    addUser: {
        id: 'sts-user-management-ui.addUser',
        defaultMessage: 'Add User',
    },
    addUserOption: {
        id: 'sts-user-management-ui.addUser',
        defaultMessage: 'Add a new user',
    },
    addGuestUser: {
        id: 'sts-user-management-ui.addUser',
        defaultMessage: 'Add Guest User',
    },
    firstNameAndLastNameRequired: {
        id: 'sts-user-management-ui.firstNameAndLastNameRequired',
        defaultMessage: 'First name and last name are required',
    },
    contactProfileLinkSuccess: {
        id: 'sts-user-management-ui.profileLinkSuccess',
        defaultMessage: 'Successfully linked contact',
    },
    contactProfileLinkFailed: {
        id: 'sts-user-management-ui.profileLinkFailed',
        defaultMessage:
            'We couldn’t link contact profile right now. Please try again or refresh the page if this persists.',
    },
    createNewProfileSuccess: {
        id: 'sts-user-management-ui.createNewProfileSuccess',
        defaultMessage: 'Successfully created contact profile',
    },
    createNewProfileFailed: {
        id: 'sts-user-management-ui.createNewProfileFailed',
        defaultMessage:
            'We couldn’t save contact profile right now. Please try again or refresh the page if this persists.',
    },
    inviteAUser: {
        id: 'sts-user-management-ui.inviteAUser',
        defaultMessage: 'Invite User',
    },
    userProfile: {
        id: 'sts-user-management-ui.userProfile',
        defaultMessage: 'User Profile',
    },
    userProfileWithLowercase: {
        id: 'sts-user-management-ui.userProfileWithLowercase',
        defaultMessage: 'User profile',
    },
    userProfileDesc: {
        id: 'sts-user-management-ui.userProfileDesc',
        defaultMessage: "Edit user's profile to keep the details and user access updated.",
    },
    userProfileTitlePart: {
        id: 'sts-user-management-ui.userProfileTitlePart',
        defaultMessage: "'s profile",
    },
    userProfileLowercase: {
        id: 'sts-user-management-ui.userProfileLowercase',
        defaultMessage: 'profile',
    },
    userMultiFactorAuthentication: {
        id: 'sts-user-management-ui.userMultiFactorAuthentication',
        defaultMessage: 'Multi-Factor Authentication',
    },
    userMFASubTitle: {
        id: 'sts-user-management-ui.userMFASubTitle',
        defaultMessage: 'To keep your account secure, we need you to set up at least one MFA method.',
    },
    userMFASubHeading: {
        id: 'sts-user-management-ui.userMFASubHeading',
        defaultMessage: 'Search and enter a DUO Provider Name that you want to assign to this user.',
    },
    unavailable: {
        id: 'sts-user-management-ui.unavailable',
        defaultMessage: 'Unavailable',
    },
    userMfaTurnedOff: {
        id: 'sts-user-management-ui.userMfaTurnedOff',
        defaultMessage: 'Turned off',
    },
    userMfaDisable: {
        id: 'sts-user-management-ui.userMfaDisable',
        defaultMessage: 'Disable All MFA',
    },
    userMfaEnable: {
        id: 'sts-user-management-ui.userMfaEnable',
        defaultMessage: 'Enable All MFA',
    },
    authTitleMfaTurnedOff: {
        id: 'sts-user-management-ui.authTitleMfaTurnedOff',
        defaultMessage: 'MFA Turned Off',
    },
    authTitleMfaTurnedOn: {
        id: 'sts-user-management-ui.authTitleMfaTurnedOn',
        defaultMessage: 'MFA Turned On',
    },
    authTitleExternal: {
        id: 'sts-user-management-ui.authTitleExternal',
        defaultMessage: 'External Authentication',
    },
    userPasswordSettings: {
        id: 'sts-user-management-ui.userPasswordSettings',
        defaultMessage: 'Password Settings',
    },
    userPasswordText: {
        id: 'sts-user-management-ui.userPasswordText',
        defaultMessage: 'This will send a reset password email to this user',
    },
    userEmailMfa: {
        id: 'sts-user-management-ui.userEmailMfa',
        defaultMessage: 'Email MFA',
    },
    userAuthMfa: {
        id: 'sts-user-management-ui.userAuthMfa',
        defaultMessage: 'Auth MFA',
    },
    userDuoMfa: {
        id: 'sts-user-management-ui.userDuoMfa',
        defaultMessage: 'DUO MFA',
    },
    selectProvider: {
        id: 'sts-user-management-ui.selectProvider',
        defaultMessage: 'Select Provider',
    },
    duoProviderName: {
        id: 'sts-user-management-ui.duoProviderName',
        defaultMessage: 'DUO Provider Name',
    },
    duoUsername: {
        id: 'sts-user-management-ui.duoUsername',
        defaultMessage: 'DUO Username',
    },
    enterUsername: {
        id: 'sts-user-management-ui.enterUsername',
        defaultMessage: 'Enter username',
    },
    productAccess: {
        id: 'sts-user-management-ui.productAccess',
        defaultMessage: 'Product Access',
    },
    accessGranted: {
        id: 'sts-user-management-ui.accessGranted',
        defaultMessage: 'Access Granted',
    },
    accessGrant: {
        id: 'sts-user-management-ui.accessGrant',
        defaultMessage: 'Access grant',
    },
    noAccess: {
        id: 'sts-user-management-ui.noAccess',
        defaultMessage: 'No Access',
    },
    assigned: {
        id: 'sts-user-management-ui.assigned',
        defaultMessage: 'Assigned',
    },
    rolesAssigned: {
        id: 'sts-user-management-ui.rolesAssigned',
        defaultMessage: 'Roles Assigned',
    },
    assignedRoles: {
        id: 'sts-user-management-ui.assignedRoles',
        defaultMessage: 'Assigned Identity roles',
    },
    clear: {
        id: 'sts-user-management-ui.clear',
        defaultMessage: 'Clear',
    },
    clearAll: {
        id: 'sts-user-management-ui.clearAll',
        defaultMessage: 'Clear All',
    },
    sendReset: {
        id: 'sts-user-management-ui.sendReset',
        defaultMessage: 'Send Reset',
    },
    ssoHome: {
        id: 'sts-user-management-ui.ssoHome',
        defaultMessage: 'SSO/Home',
    },
    connectWiseAccount: {
        id: 'sts-user-management-ui.connectWiseAccount',
        defaultMessage: 'ConnectWise Account',
    },
    connectWiseHomeAndUniversity: {
        id: 'sts-user-management-ui.connectWiseHomeAndUniversity',
        defaultMessage: 'ConnectWise Home & University',
    },
    removeRolesText: {
        id: 'sts-user-management-ui.removeRolesText',
        defaultMessage: 'Select roles from above and click the down arrow to remove.',
    },
    availableRoles: {
        id: 'sts-user-management-ui.availableRoles',
        defaultMessage: 'Available roles',
    },
    selectRoleType: {
        id: 'sts-user-management-ui.selectRoleType',
        defaultMessage: 'Select Role Type',
    },
    selectProductSpecificAttr: {
        id: 'sts-user-management-ui.selectProductSpecificAttr',
        defaultMessage: 'Select Product Specific Attribute',
    },
    chooseAnOption: {
        id: 'sts-user-management-ui.chooseAnOption',
        defaultMessage: 'Choose an option',
    },
    selectResourcesToAssign: {
        id: 'sts-user-management-ui.selectResourcesToAssign',
        defaultMessage: 'Select Resources to Assign to Role',
    },
    allowUserAccess: {
        id: 'sts-user-management-ui.allowUserAccess',
        defaultMessage: 'Allow user access',
    },
    noAccessTextManageAutomateSell: {
        id: 'sts-user-management-ui.noAccessTextManageAutomateSell',
        defaultMessage: `Maintain these roles and permissions within the {productName} product. Please see this {universityDocumentation} for additional information.`,
    },
    noAccessTextControl: {
        id: 'sts-user-management-ui.noAccessTextControl',
        defaultMessage: `Maintain the roles and permissions for Control under the ConnectWise Account options above. Please see this {universityDocumentation} for additional information.`,
    },
    noAccessTextOthers: {
        id: 'sts-user-management-ui.noAccessTextOthers',
        defaultMessage: `Please review the documentation for this product to determine how roles and permissions should be set.`,
    },
    universityDocumentation: {
        id: 'sts-user-management-ui.universityDocumentation',
        defaultMessage: 'University documentation',
    },
    sendInvite: {
        id: 'sts-user-management-ui.sendInvite',
        defaultMessage: 'Send Invite',
    },
    userAdded: {
        id: 'sts-user-management-ui.userAdded',
        defaultMessage: 'New user invite is sent',
    },
    assignRoles: {
        id: 'sts-user-management-ui.selectRoles',
        defaultMessage: 'Assign Roles',
    },
    removeRoles: {
        id: 'sts-user-management-ui.removeRoles',
        defaultMessage: 'Remove Roles',
    },
    selectWhichRolesToAssign: {
        id: 'sts-user-management-ui.selectWhichRolesToAssign',
        defaultMessage: 'Select which roles to assign',
    },
    selectWhichProductsToAllowAccess: {
        id: 'sts-user-management-ui.selectWhichProductsToAllowAccess',
        defaultMessage: 'Select which products to allow access',
    },
    searchProducts: {
        id: 'sts-user-management-ui.searchProducts',
        defaultMessage: 'Search Products',
    },
    invite: {
        id: 'sts-user-management-ui.invite',
        defaultMessage: 'Approve',
    },
    deny: {
        id: 'sts-user-management-ui.deny',
        defaultMessage: 'Deny',
    },
    editUser: {
        id: 'sts-user-management-ui.editUser',
        defaultMessage: 'Edit User',
    },
    editGuestUser: {
        id: 'sts-user-management-ui.editUser',
        defaultMessage: 'Edit Guest User',
    },
    editRole: {
        id: 'sts-user-management-ui.editRole',
        defaultMessage: 'Edit Role',
    },
    updateSave: {
        id: 'sts-user-management-ui.updateSave',
        defaultMessage: 'Update/Save',
    },
    role: {
        id: 'sts-user-management-ui.role',
        defaultMessage: 'Role',
    },
    identityRole: {
        id: 'sts-user-management-ui.identityRole',
        defaultMessage: 'Identity Role',
    },
    admin: {
        id: 'sts-user-management-ui.admin',
        defaultMessage: 'Admin',
    },
    billingAdmin: {
        id: 'sts-user-management-ui.billingAdmin',
        defaultMessage: 'Billing Admin',
    },
    changeProductAccess: {
        id: 'sts-user-management-ui.changeProductAccess',
        defaultMessage: 'Change Product Access',
    },
    changeProductAccessConfirmation: {
        id: 'sts-user-management-ui.changeProductAccessConfirmation',
        defaultMessage: 'You are about to change access to the products for all the users you selected.',
    },
    disableAccess: {
        id: 'sts-user-management-ui.disableAccess',
        defaultMessage: 'Disable Access',
    },
    disableAccount: {
        id: 'sts-user-management-ui.disableAccount',
        defaultMessage: 'Disable Account',
    },
    invitationPending: {
        id: 'sts-user-management-ui.invitationPending',
        defaultMessage: 'Invitation Pending',
    },
    invitationExpired: {
        id: 'sts-user-management-ui.invitationExpired',
        defaultMessage: 'Invitation Expired',
    },
    disableConfirmation: {
        id: 'sts-user-management-ui.disableConfirmation',
        defaultMessage: 'Prevent the selected user(s) from accessing the ConnectWise Portal?',
    },
    disable: {
        id: 'sts-user-management-ui.disable',
        defaultMessage: 'Disable',
    },
    disableUserAlert: {
        id: 'sts-user-management-ui.disableUserAlert',
        defaultMessage: 'Are you sure you want to disable the user?',
    },
    disableUserAlertSuccess: {
        id: 'sts-user-management-ui.disableUserAlertSuccess',
        defaultMessage: 'User has been disabled successfully.',
    },
    enableAccess: {
        id: 'sts-user-management-ui.enableAccess',
        defaultMessage: 'Enable Access',
    },
    enableConfirmation: {
        id: 'sts-user-management-ui.enableConfirmation',
        defaultMessage: 'Allow the selected user(s) to access the ConnectWise Portal?',
    },
    enable: {
        id: 'sts-user-management-ui.enable',
        defaultMessage: 'Enable',
    },
    reset: {
        id: 'sts-user-management-ui.reset',
        defaultMessage: 'Reset',
    },
    resetAuthAppMFAConfirmation: {
        id: 'sts-user-management-ui.resetAuthAppMFAConfirmation',
        defaultMessage: 'Are you sure you want to Reset the MFA configuration settings for Authenticator app?',
    },
    resend: {
        id: 'sts-user-management-ui.resend',
        defaultMessage: 'Resend',
    },
    forgetMFA: {
        id: 'sts-user-management-ui.forgetMFA',
        defaultMessage: 'Forget MFA',
    },
    forgetMFAConfirmation: {
        id: 'sts-user-management-ui.forgetMFAConfirmation',
        defaultMessage:
            'Continuing with this option will remove any applied MFA configuration for all selected users. Are you sure you want to continue?',
    },
    yesForget: {
        id: 'sts-user-management-ui.yesForget',
        defaultMessage: 'YES, FORGET',
    },
    forget: {
        id: 'sts-user-management-ui.forget',
        defaultMessage: 'Forget',
    },
    MFAForgotten: {
        id: 'sts-user-management-ui.MFAForgotten',
        defaultMessage: 'Multi-factor authentication forgotten',
    },
    failedForgetMFA: {
        id: 'sts-user-management-ui.failedForgetMFA',
        defaultMessage:
            'We couldn’t forget user multi-factor authentication right now. Please try again or refresh the page if this persists.',
    },
    resetPassword: {
        id: 'sts-user-management-ui.resetPassword',
        defaultMessage: 'Reset Password',
    },
    resetConfirmation: {
        id: 'sts-user-management-ui.resetConfirmation',
        defaultMessage:
            'Choosing this option will send an email to all selected users requiring them to reset their password. Are you sure you want to continue?',
    },
    userResendConfirmation: {
        id: 'sts-user-management-ui.userResendConfirmation',
        defaultMessage:
            'Continuing with this option will send an email to all selected users inviting them to join your tenant. Are you sure you want to continue?',
    },
    delete: {
        id: 'sts-user-management-ui.delete',
        defaultMessage: 'Delete',
    },
    deleteUser: {
        id: 'sts-user-management-ui.deleteUser',
        defaultMessage: 'Delete User',
    },
    deleteUserConfirmation: {
        id: 'sts-user-management-ui.deleteUserConfirmation',
        defaultMessage:
            'Continuing with this option will delete the user accounts for all selected users. This could potentially affect the functionality of any integrations associated with these users, resulting in integration failures. Are you sure you want to continue?',
    },
    name: {
        id: 'sts-user-management-ui.name',
        defaultMessage: 'Name',
    },
    email: {
        id: 'sts-user-management-ui.email',
        defaultMessage: 'Email',
    },
    duplicateEmailAddress: {
        id: 'sts-user-management-ui.duplicateEmailAddress',
        defaultMessage: 'Email address is already taken.',
    },
    userAlreadyExists: {
        id: 'sts-user-management-ui.userAlreadyExists',
        defaultMessage: 'Already a user, product access will be updated.',
    },
    portalAccess: {
        id: 'sts-user-management-ui.portalAccess',
        defaultMessage: 'Access',
    },
    linkContact: {
        id: 'sts-user-management-ui.linkContact',
        defaultMessage: 'Link Contact',
    },
    save: {
        id: 'sts-user-management-ui.save',
        defaultMessage: 'Save',
    },
    saveApplication: {
        id: 'sts-user-management-ui.saveApplication',
        defaultMessage: 'Save Application',
    },
    cancel: {
        id: 'sts-user-management-ui.cancel',
        defaultMessage: 'Cancel',
    },
    confirm: {
        id: 'sts-user-management-ui.confirm',
        defaultMessage: 'Confirm',
    },
    roles: {
        id: 'sts-user-management-ui.roles',
        defaultMessage: 'Roles',
    },
    identityRoles: {
        id: 'sts-user-management-ui.identityRoles',
        defaultMessage: 'Identity Roles',
    },
    products: {
        id: 'sts-user-management-ui.products',
        defaultMessage: 'Products',
    },
    product: {
        id: 'sts-user-management-ui.product',
        defaultMessage: 'Product',
    },
    instance: {
        id: 'sts-user-management-ui.instance',
        defaultMessage: 'Instance',
    },
    roleDescription: {
        id: 'sts-user-management-ui.roleDescription',
        defaultMessage:
            'Create roles to control what users can access in the ConnectWise portal. We provide the following default roles: Admin, Billing Admin, and User Management',
    },
    addRoleButton: {
        id: 'sts-user-management-ui.addRoleButton',
        defaultMessage: 'Create Role',
    },
    addIdentityRoleButton: {
        id: 'sts-user-management-ui.addIdentityRoleButton',
        defaultMessage: 'Add Identity Role',
    },
    addRole: {
        id: 'sts-user-management-ui.addRole',
        defaultMessage: 'Add a New Role',
    },
    edit: {
        id: 'sts-user-management-ui.edit',
        defaultMessage: 'Edit',
    },
    description: {
        id: 'sts-user-management-ui.description',
        defaultMessage: 'Description',
    },
    deleteRole: {
        id: 'sts-user-management-ui.deleteRole',
        defaultMessage: 'Delete Role',
    },
    deleteRoleConfirmation: {
        id: 'sts-user-management-ui.deleteRoleConfirmation',
        defaultMessage: 'Are you sure you want to delete this role?',
    },
    firstName: {
        id: 'sts-user-management-ui.firstName',
        defaultMessage: 'First Name',
    },
    lastName: {
        id: 'sts-user-management-ui.lastName',
        defaultMessage: 'Last Name',
    },
    middleName: {
        id: 'sts-user-management-ui.middleName',
        defaultMessage: 'Middle Name',
    },
    currentUsers: {
        id: 'sts-user-management-ui.currentUsers',
        defaultMessage: 'Users',
    },
    hireDate: {
        id: 'sts-user-management-ui.hireDate',
        defaultMessage: 'Hire Date',
    },
    hireDatePlaceHolder: {
        id: 'sts-user-management-ui.hireDatePlaceHolder',
        defaultMessage: 'Enter hire date',
    },
    importedUsers: {
        id: 'sts-user-management-ui.importedUsers',
        defaultMessage: 'Imported Users',
    },
    importedUsersDescription: {
        id: 'sts-user-management-ui.importedUsersDescription',
        defaultMessage: "Here's where you'll find the users imported from your products.",
    },
    newUser: {
        id: 'sts-user-management-ui.newUser',
        defaultMessage: 'New User',
    },
    existingUser: {
        id: 'sts-user-management-ui.existingUser',
        defaultMessage: 'Existing User',
    },
    crossTenant: {
        id: 'sts-user-management-ui.crossTenant',
        defaultMessage: 'Email Taken',
    },
    crossTenantTitleText: {
        id: 'sts-user-management-ui.crossTenantTitleText',
        defaultMessage: 'This email already exists in a different SSO account',
    },
    usersNeedApproval: {
        id: 'sts-user-management-ui.usersNeedApproval',
        defaultMessage: 'Users Need Approval',
    },
    contactMatchesFound: {
        id: 'sts-user-management-ui.contactMatchesFound',
        defaultMessage: 'Contacts Matches Found',
    },
    selectAuthenticationMethod: {
        id: 'sts-user-management-ui.selectAuthenticationMethod',
        defaultMessage: 'Select Authentication Method to Approve',
    },
    setAuthenticationMethod: {
        id: 'sts-user-management-ui.setAuthenticationMethod',
        defaultMessage:
            'Approving the selected users will grant them access to your ConnectWise SSO and apply the selected authentication method.',
    },
    selectAMethod: {
        id: 'sts-user-management-ui.selectAMethod',
        defaultMessage: 'Select a method',
    },
    reject: {
        id: 'sts-user-management-ui.reject',
        defaultMessage: 'Reject',
    },
    rejectionConfirmation: {
        id: 'sts-user-management-ui.rejectionConfirmation',
        defaultMessage: 'Selected users are rejected',
    },
    pendingInvites: {
        id: 'sts-user-management-ui.pendingInvites',
        defaultMessage: 'Pending Invites',
    },
    pendingInvitesDescription: {
        id: 'sts-user-management-ui.pendingInvitesDescription',
        defaultMessage: "Here's where you'll find the users that have been invited but haven't created accounts yet.",
    },
    connectWiseSingleSignOn: {
        id: 'sts-user-management-ui.connectWiseSingleSignOn',
        defaultMessage: 'ConnectWise Single Sign-On',
    },
    productsDescription: {
        id: 'sts-user-management-ui.productsDescription',
        defaultMessage: 'Generate a token and enter it into your ConnectWise products to connect them.',
    },
    generateToken: {
        id: 'sts-user-management-ui.generateToken',
        defaultMessage: 'Generate Token',
    },
    addClient: {
        id: 'sts-user-management-ui.addClient',
        defaultMessage: 'ADD CLIENT',
    },
    registrationToken: {
        id: 'sts-user-management-ui.registrationToken',
        defaultMessage: 'Registration Token',
    },
    copy: {
        id: 'sts-user-management-ui.copy',
        defaultMessage: 'Copy',
    },
    tokenOnlyValidFor: {
        id: 'sts-user-management-ui.tokenOnlyValidFor',
        defaultMessage: 'Token is only valid for 30 minutes.',
    },
    tokenCopied: {
        id: 'sts-user-management-ui.tokenCopied',
        defaultMessage: 'Token copied',
    },
    passwordCopied: {
        id: 'sts-user-management-ui.passwordCopied',
        defaultMessage: 'Password copied',
    },
    username: {
        id: 'sts-user-management-ui.username',
        defaultMessage: 'Username',
    },
    resendInvite: {
        id: 'sts-user-management-ui.resendInvite',
        defaultMessage: 'Resend Invite',
    },
    downloadUsersList: {
        id: 'sts-user-management-ui.downloadUsersList',
        defaultMessage: 'Download Users List',
    },
    inviteLink: {
        id: 'sts-user-management-ui.inviteLink',
        defaultMessage: 'Invite Link',
    },
    editImportedUser: {
        id: 'sts-user-management-ui.editImportedUser',
        defaultMessage: 'Edit Email',
    },
    deleteImportedUser: {
        id: 'sts-user-management-ui.deleteImportedUser',
        defaultMessage: 'Reject user access',
    },
    denyImportedUser: {
        id: 'sts-user-management-ui.denyImportedUser',
        defaultMessage: 'Deny User Access',
    },
    deleteImportedUserConfirmation: {
        id: 'sts-user-management-ui.deleteImportedUserConfirmation',
        defaultMessage: 'Are you sure you want to reject user access for the selected users?',
    },
    denyImportedUserConfirmation: {
        id: 'sts-user-management-ui.denyImportedUserConfirmation',
        defaultMessage: 'Are you sure you want to deny access for the selected users?',
    },
    someDeniedInvitations: {
        id: 'sts-user-management-ui.someDenyInvitationSent',
        defaultMessage: 'Some users were not able to be added to this account.',
    },
    deniedInvitation: {
        id: 'sts-user-management-ui.denyInvitationSent',
        defaultMessage: "This user's email address is already taken, they cannot be added to this account.",
    },
    invitationSent: {
        id: 'sts-user-management-ui.invitationSent',
        defaultMessage: 'Invitation email has been sent',
    },
    invitationSentFailed: {
        id: 'sts-user-management-ui.invitationSentFailed',
        defaultMessage: 'Invitation already sent, please wait 5 minutes to resend invite',
    },
    deletePendingInvite: {
        id: 'sts-user-management-ui.deletePendingInvite',
        defaultMessage: 'Delete Pending Invite',
    },
    deletePendingInviteConfirmation: {
        id: 'sts-user-management-ui.deletePendingInviteConfirmation',
        defaultMessage: 'Delete the selected pending invite(s)?',
    },
    usersAssigned: {
        id: 'sts-user-management-ui.usersAssigned',
        defaultMessage: 'Users',
    },
    addUsers: {
        id: 'sts-user-management-ui.addUsers',
        defaultMessage: 'Add Users',
    },
    clonePreviousUser: {
        id: 'sts-user-management-ui.clonePreviousUser',
        defaultMessage: 'Clone Previous User',
    },
    addingNewUser: {
        id: 'sts-user-management-ui.addingNewUser',
        defaultMessage: 'Add New User',
    },
    closeAndReturn: {
        id: 'sts-user-management-ui.closeAndReturn',
        defaultMessage: 'Close and Return to the Users Screen',
    },
    congrats: {
        id: 'sts-user-management-ui.congrats',
        defaultMessage: 'Congrats!',
    },
    addUserSuccessTitle: {
        id: 'sts-user-management-ui.addUserSuccessTitle',
        defaultMessage: 'You have successfully added a user.',
    },
    addUserSuccessDesc: {
        id: 'sts-user-management-ui.addUserSuccessDesc',
        defaultMessage:
            "Click the relevant option below to add a fresh new user or same as previous user's roles & permissions.",
    },
    displayName: {
        id: 'sts-user-management-ui.displayName',
        defaultMessage: 'Display Name',
    },
    clientId: {
        id: 'sts-user-management-ui.clientId',
        defaultMessage: 'Client ID',
    },
    control: {
        id: 'sts-user-management-ui.control',
        defaultMessage: 'Control',
    },
    sell: {
        id: 'sts-user-management-ui.sell',
        defaultMessage: 'Sell',
    },
    automate: {
        id: 'sts-user-management-ui.automate',
        defaultMessage: 'Automate',
    },
    manage: {
        id: 'sts-user-management-ui.manage',
        defaultMessage: 'Manage',
    },
    other: {
        id: 'sts-user-management-ui.other',
        defaultMessage: 'Other',
    },
    addApplication: {
        id: 'sts-user-management-ui.addApplication',
        defaultMessage: 'Add Application',
    },
    configureApplication: {
        id: 'sts-user-management-ui.configureApplication',
        defaultMessage: 'Configure Application',
    },
    selectApplicationType: {
        id: 'sts-user-management-ui.selectApplicationType',
        defaultMessage: 'Select Application Type',
    },
    editApplication: {
        id: 'sts-user-management-ui.editApplication',
        defaultMessage: 'Edit Application',
    },
    deleteApplication: {
        id: 'sts-user-management-ui.deleteApplication',
        defaultMessage: 'Delete Application',
    },
    deleteApplicationConfirmation: {
        id: 'sts-user-management-ui.deleteApplicationConfirmation',
        defaultMessage: 'Delete the selected application(s)?',
    },
    singlePageApplication: {
        id: 'sts-user-management-ui.singlePageApplication',
        defaultMessage: 'Single Page Application',
    },
    singlePageApplicationHelpText: {
        id: 'sts-user-management-ui.singlePageApplicationHelpText',
        defaultMessage:
            'A client-side application running in a browser.\nThese applications cannot be trusted to keep secrets or use refresh tokens.\nTokens will be sent through via the browser and will be visible to the user.',
    },
    singlePageApplicationLegacy: {
        id: 'sts-user-management-ui.singlePageApplicationLegacy',
        defaultMessage: 'Single Page Application (Legacy)',
    },
    singlePageApplicationLegacyHelpText: {
        id: 'sts-user-management-ui.singlePageApplicationLegacyHelpText',
        defaultMessage:
            'A client-side application running in a browser using previous OAuth Working Group recommendations.\nThese applications cannot be trusted to keep secrets or use refresh tokens.\nTokens will be sent through via the browser and will be visible to the user.',
    },
    native: {
        id: 'sts-user-management-ui.native',
        defaultMessage: 'Native',
    },
    nativeHelpText: {
        id: 'sts-user-management-ui.nativeHelpText',
        defaultMessage:
            "A desktop or mobile application running on a user's device.\nThese applications cannot be trusted to keep a secret but can use refresh tokens.\nToken visibility dependent on browser and redirect URI choice.",
    },
    webApplication: {
        id: 'sts-user-management-ui.webApplication',
        defaultMessage: 'Web Application',
    },
    webApplicationHelpText: {
        id: 'sts-user-management-ui.webApplicationHelpText',
        defaultMessage:
            'A server-side application running on your infrastructure.\nThese applications can be trusted to keep a secret and use refresh tokens.\nTokens will be sent to a back-end server and will not be visible to the user.',
    },
    machine: {
        id: 'sts-user-management-ui.machine',
        defaultMessage: 'Machine',
    },
    machineHelpText: {
        id: 'sts-user-management-ui.machineHelpText',
        defaultMessage:
            'A machine-to-machine method of communication.\nNo users are involved in the process.\nTokens will be sent via back-channel communication.',
    },
    authCodeFlowPkce: {
        id: 'sts-user-management-ui.authCodeFlowPkce',
        defaultMessage: 'Authorization code flow + PKCE',
    },
    requirePkce: {
        id: 'sts-user-management-ui.requirePkce',
        defaultMessage: 'Require PKCE',
    },
    implicitFlow: {
        id: 'sts-user-management-ui.implicitFlow',
        defaultMessage: 'Implicit flow',
    },
    hybridFlow: {
        id: 'sts-user-management-ui.hybridFlow',
        defaultMessage: 'Hybrid flow with client authentication',
    },
    clientCredentials: {
        id: 'sts-user-management-ui.clientCredentials',
        defaultMessage: 'Client credentials',
    },
    editProductInstance: {
        id: 'sts-user-management-ui.editProductInstance',
        defaultMessage: 'Edit Product Instance',
    },
    deleteProductInstance: {
        id: 'sts-user-management-ui.deleteProductInstance',
        defaultMessage: 'Delete Product Instance',
    },
    deleteProductInstanceConfirmation: {
        id: 'sts-user-management-ui.deleteProductInstanceConfirmation',
        defaultMessage: 'Delete the selected product instance?',
    },
    resetPasswordSent: {
        id: 'sts-user-management-ui.resetPasswordSent',
        defaultMessage: 'Email to reset the password has been sent',
    },
    userUpdated: {
        id: 'sts-user-management-ui.userUpdated',
        defaultMessage: 'User updated successfully.',
    },
    userDeleted: {
        id: 'sts-user-management-ui.userDeleted',
        defaultMessage: 'User(s) deleted',
    },
    disabled: {
        id: 'sts-user-management-ui.disabled',
        defaultMessage: 'Disabled',
    },
    enabled: {
        id: 'sts-user-management-ui.enabled',
        defaultMessage: 'Enabled',
    },
    valid: {
        id: 'sts-user-management-ui.valid',
        defaultMessage: 'Valid',
    },
    expired: {
        id: 'sts-user-management-ui.expired',
        defaultMessage: 'Expired',
    },
    inactive: {
        id: 'sts-user-management-ui.inactive',
        defaultMessage: 'Inactive',
    },
    roleUpdated: {
        id: 'sts-user-management-ui.roleUpdated',
        defaultMessage: 'Role updated',
    },
    failedGetUsers: {
        id: 'sts-user-management-ui.failedGetUsers',
        defaultMessage: 'We couldn’t fetch users right now. Please refresh the page and try again.',
    },
    failedGetUser: {
        id: 'sts-user-management-ui.failedGetUser',
        defaultMessage: 'We couldn’t fetch user right now. Please refresh the page and try again.',
    },
    failedUpdateUser: {
        id: 'sts-user-management-ui.failedUpdateUser',
        defaultMessage: 'We couldn’t update user right now. Please refresh the page and try again.',
    },
    failedDeleteUser: {
        id: 'sts-user-management-ui.failedDeleteUser',
        defaultMessage: 'We couldn’t delete user(s) right now. Please refresh the page and try again.',
    },
    failedInviteImportedUser: {
        id: 'sts-user-management-ui.failedInviteImportedUser',
        defaultMessage: 'We couldn’t invite imported user(s) right now. Please refresh the page and try again.',
    },
    failedGetPendingInvites: {
        id: 'sts-user-management-ui.failedGetPendingInvites',
        defaultMessage: 'We couldn’t fetch all the details right now. Please refresh the page and try again.',
    },
    failedDeletePendingInvite: {
        id: 'sts-user-management-ui.failedDeletePendingInvite',
        defaultMessage: 'We couldn’t delete pending invite right now. Please refresh the page and try again.',
    },
    failedReinviteUser: {
        id: 'sts-user-management-ui.failedReinviteUser',
        defaultMessage: 'We couldn’t reinvite user right now. Please refresh the page and try again.',
    },
    failedGetRegistrationToken: {
        id: 'sts-user-management-ui.failedGetRegistrationToken',
        defaultMessage: 'We couldn’t fetch the registration token right now. Please refresh the page and try again.',
    },
    failedGetProducts: {
        id: 'sts-user-management-ui.failedGetProducts',
        defaultMessage: 'We couldn’t fetch the products right now. Please refresh the page and try again.',
    },
    failedGetProductInstance: {
        id: 'sts-user-management-ui.failedGetProductInstance',
        defaultMessage: 'We couldn’t fetch product instance right now. Please refresh the page and try again.',
    },
    failedLoadResources: {
        id: 'sts-user-management-ui.failedLoadResources',
        defaultMessage:
            'We couldn’t fetch all resources right now. Please try again or refresh the page if this persists.',
    },
    failedGetApplication: {
        id: 'sts-user-management-ui.failedGetApplication',
        defaultMessage: 'We couldn’t fetch all the details right now. Please refresh the page and try again.',
    },
    failedGetProductInstanceUsers: {
        id: 'sts-user-management-ui.failedGetProductInstanceUsers',
        defaultMessage:
            'We couldn’t fetch all the users associated with this product instance right now. Please refresh the page and try again.',
    },
    failedGetProductInstanceSecrets: {
        id: 'sts-user-management-ui.failedGetProductInstanceSecrets',
        defaultMessage: 'We couldn’t fetch all the details right now. Please refresh the page and try again.',
    },
    failedGetApplicationUsers: {
        id: 'sts-user-management-ui.failedGetApplicationUsers',
        defaultMessage: 'We couldn’t fetch all the details right now. Please refresh the page and try again.',
    },
    failedUpdateProductInstance: {
        id: 'sts-user-management-ui.failedUpdateProductInstance',
        defaultMessage: 'We couldn’t update the product instance right now. Please refresh the page and try again.',
    },
    failedDeleteProductInstanceSecret: {
        id: 'sts-user-management-ui.failedDeleteProductInstanceSecret',
        defaultMessage: 'We couldn’t complete this action right now. Please refresh the page and try again.',
    },
    failedDeleteProductInstance: {
        id: 'sts-user-management-ui.failedDeleteProductInstance',
        defaultMessage: 'We couldn’t delete the product instance right now. Please refresh the page and try again.',
    },
    failedDeleteApplication: {
        id: 'sts-user-management-ui.failedDeleteApplication',
        defaultMessage: 'We couldn’t complete this action right now. Please refresh the page and try again.',
    },
    failedGetRole: {
        id: 'sts-user-management-ui.failedGetRole',
        defaultMessage: 'We couldn’t fetch roles right now. Please refresh the page and try again.',
    },
    failedGetRoles: {
        id: 'sts-user-management-ui.failedGetRoles',
        defaultMessage: 'We couldn’t fetch all the identity roles right now. Please refresh the page and try again.',
    },
    failedGetRoleUsers: {
        id: 'sts-user-management-ui.failedGetRoleUsers',
        defaultMessage:
            'We couldn’t fetch all the users associated with this identity role right now. Please refresh the page and try again.',
    },
    failedUpdateRoleUsers: {
        id: 'sts-user-management-ui.failedUpdateRoleUsers',
        defaultMessage:
            'We couldn’t update all the users associated with this identity role right now. Please try again or refresh the page if this persists.',
    },
    failedCreateRole: {
        id: 'sts-user-management-ui.failedCreateRole',
        defaultMessage: 'We couldn’t save the role right now. Please try again or refresh the page if this persists.',
    },
    failedUpdateRole: {
        id: 'sts-user-management-ui.failedUpdateRole',
        defaultMessage: 'We couldn’t update the role right now. Please try again or refresh the page if this persists.',
    },
    failedDeleteRole: {
        id: 'sts-user-management-ui.failedDeleteRole',
        defaultMessage: 'We couldn’t delete the role right now. Please try again or refresh the page if this persists.',
    },
    failedGetUserRoles: {
        id: 'sts-user-management-ui.failedGetUserRoles',
        defaultMessage: GENERIC_ERROR_MESSAGES.GET,
    },
    failedGetUserProducts: {
        id: 'sts-user-management-ui.failedGetUserProducts',
        defaultMessage: 'We couldn’t fetch all the details right now. Please refresh the page and try again.',
    },
    failedUpdateUserRoles: {
        id: 'sts-user-management-ui.failedUpdateUserRoles',
        defaultMessage: GENERIC_ERROR_MESSAGES.CREATE_UPDATE_DELETE,
    },
    failedUpdateUserProducts: {
        id: 'sts-user-management-ui.failedUpdateUserProducts',
        defaultMessage: GENERIC_ERROR_MESSAGES.CREATE_UPDATE_DELETE,
    },
    failedCreateUser: {
        id: 'sts-user-management-ui.failedCreateUser',
        defaultMessage: 'We couldn’t create the user right now. Please try again or refresh the page if this persists.',
    },
    failedResetUserPassword: {
        id: 'sts-user-management-ui.failedResetUserPassword',
        defaultMessage:
            'We couldn’t reset the password for this user right now. Please try again or refresh the page if this persists.',
    },
    failedDisableUser: {
        id: 'sts-user-management-ui.failedDisableUser',
        defaultMessage:
            'We couldn’t disable the user right now. Please try again or refresh the page if this persists.',
    },
    failedEnableUser: {
        id: 'sts-user-management-ui.failedEnableUser',
        defaultMessage: 'We couldn’t enable the user right now. Please try again or refresh the page if this persists.',
    },
    failedUpdateProductInstanceUsers: {
        id: 'sts-user-management-ui.failedUpdateProductInstanceUsers',
        defaultMessage:
            '	We couldn’t update the users associated with this product instance right now. Please try again or refresh the page if this persists.',
    },
    applications: {
        id: 'sts-user-management-ui.applications',
        defaultMessage: 'Applications',
    },
    support: {
        id: 'sts-user-management-ui.support',
        defaultMessage: 'Support',
    },
    connectWiseSupport: {
        id: 'sts-user-management-ui.connectWiseSupport',
        defaultMessage: 'ConnectWise Support',
    },
    allowSupport: {
        id: 'sts-user-management-ui.allowSupport',
        defaultMessage: 'Allow our support team to access your account for any issues.',
    },
    failedGetSupport: {
        id: 'sts-user-management-ui.failedGetSupport',
        defaultMessage: GENERIC_ERROR_MESSAGES.GET,
    },
    failedUpdateSupport: {
        id: 'sts-user-management-ui.failedUpdateSupport',
        defaultMessage: GENERIC_ERROR_MESSAGES.CREATE_UPDATE_DELETE,
    },
    supportEnabled: {
        id: 'sts-user-management-ui.supportEnabled',
        defaultMessage:
            'Our support team can now access your account. Please update your support ticket with the following password:',
    },
    close: {
        id: 'sts-user-management-ui.close',
        defaultMessage: 'Close',
    },
    all: {
        id: 'sts-user-management-ui.all',
        defaultMessage: 'All',
    },
    selectAll: {
        id: 'sts-user-management-ui.selectAll',
        defaultMessage: 'Select All',
    },
    showOnlySelected: {
        id: 'sts-user-management-ui.showOnlySelected',
        defaultMessage: 'Show only selected',
    },
    showOnlyUnselected: {
        id: 'sts-user-management-ui.showOnlyUnselected',
        defaultMessage: 'Show only unselected',
    },
    accessDenied: {
        id: 'sts-user-management-ui.accessDenied',
        defaultMessage: 'You do not have access to User Management.',
    },
    logout: {
        id: 'sts-user-management-ui.logout',
        defaultMessage: 'Logout',
    },
    questionsWeveGotAnswers: {
        id: 'sts-user-management-ui.questionsWeveGotAnswers',
        defaultMessage: "Questions? We've got answers. ",
    },
    contactUs: {
        id: 'sts-user-management-ui.contactUs',
        defaultMessage: 'Contact Us',
    },
    notAllowedToDeleteDefaultRoles: {
        id: 'sts-user-management-ui.notAllowedToDeleteDefaultRoles',
        defaultMessage:
            'We’re sorry, but you are not allowed to delete the following default roles: Admin, Billing Admin, and User Management.',
    },
    redirectUris: {
        id: 'sts-user-management-ui.redirectUris',
        defaultMessage: 'Redirect URIs',
    },
    postLogoutRedirectUris: {
        id: 'sts-user-management-ui.postLogoutRedirectUris',
        defaultMessage: 'Post Logout Redirect URIs',
    },
    allowedCorsOrigins: {
        id: 'sts-user-management-ui.allowedCorsOrigins',
        defaultMessage: 'Allowed CORS Origins',
    },
    allowedCorsOrigin: {
        id: 'sts-user-management-ui.allowedCorsOrigin',
        defaultMessage: 'Allowed CORS Origin',
    },
    redirectUriRequirements: {
        id: 'sts-user-management-ui.redirectUriRequirements',
        defaultMessage: 'Requirements:',
    },
    uriRequirementLessThan256Chars: {
        id: 'sts-user-management-ui.uriRequirement.lessThan256Chars',
        defaultMessage: 'Less than 256 characters',
    },
    uriRequirementNoWildcards: {
        id: 'sts-user-management-ui.uriRequirement.noWildcards',
        defaultMessage: 'No wildcard characters',
    },
    uriRequirementNoQueryStrings: {
        id: 'sts-user-management-ui.uriRequirement.noQueryStrings',
        defaultMessage: 'No query strings',
    },
    uriRequirementValidUri: {
        id: 'sts-user-management-ui.uriRequirement.validUri',
        defaultMessage: 'Must be a valid URI starting with https',
    },
    addUri: {
        id: 'sts-user-management-ui.addUri',
        defaultMessage: 'Add Redirect URI',
    },
    backChannelLogoutUri: {
        id: 'sts-user-management-ui.backChannelLogoutUri',
        defaultMessage: 'Back Channel Logout URI',
    },
    frontChannelLogoutUri: {
        id: 'sts-user-management-ui.frontChannelLogoutUri',
        defaultMessage: 'Front Channel Logout URI',
    },
    logoutUris: {
        id: 'sts-user-management-ui.logoutUris',
        defaultMessage: 'Logout URIs',
    },
    userStatus: {
        id: 'sts-user-management-ui.status',
        defaultMessage: 'Status',
    },
    userStatusPending: {
        id: 'sts-user-management-ui.status.pending',
        defaultMessage: 'Pending',
    },
    userStatusActive: {
        id: 'sts-user-management-ui.status.active',
        defaultMessage: 'Active',
    },
    userInviteValid: {
        id: 'sts-user-management-ui.invite.valid',
        defaultMessage: 'Valid',
    },
    userInviteInvalid: {
        id: 'sts-user-management-ui.invite.invalid',
        defaultMessage: 'Invalid',
    },
    yourRoles: {
        id: 'sts-user-management-ui.yourRoles',
        defaultMessage: 'Your roles: ',
    },
    loginMethod: {
        id: 'sts-user-management-ui.loginMethod',
        defaultMessage: 'Login Method',
    },
    localLogin: {
        id: 'sts-user-management-ui.loginMethod.localLogin',
        defaultMessage: 'Local Login',
    },
    viewEndpoints: {
        id: 'sts-user-management-ui.viewEndpoints',
        defaultMessage: 'View Endpoints',
    },
    endpoints: {
        id: 'sts-user-management-ui.Endpoints',
        defaultMessage: 'Endpoints',
    },
    failedEndpoints: {
        id: 'sts-user-management-ui.failedEndpoints',
        defaultMessage: GENERIC_ERROR_MESSAGES.GET,
    },
    authorizationEndpoint: {
        id: 'sts-user-management-ui.authorizationEndpoint',
        defaultMessage: 'Authorization Endpoint',
    },
    tokenEndpoint: {
        id: 'sts-user-management-ui.tokenEndpoint',
        defaultMessage: 'Token Endpoint',
    },
    openIdConnectMetadataDocument: {
        id: 'sts-user-management-ui.openIdConnectMetadataDocument',
        defaultMessage: 'OpenID Connect Metadata Document',
    },
    authorizationEndpointCopied: {
        id: 'sts-user-management-ui.authorizationEndpointCopied',
        defaultMessage: 'Authorization Endpoint copied',
    },
    tokenEndpointCopied: {
        id: 'sts-user-management-ui.tokenEndpointCopied',
        defaultMessage: 'Token Endpoint copied',
    },
    metadataDocumentCopied: {
        id: 'sts-user-management-ui.metadataDocumentCopied',
        defaultMessage: 'OpenID Connect Metadata Document copied',
    },
    goBack: {
        id: 'sts-user-management-ui.goBack',
        defaultMessage: 'Go Back',
    },
    overview: {
        id: 'sts-user-management-ui.overview',
        defaultMessage: 'Overview',
    },
    resources: {
        id: 'sts-user-management-ui.resources',
        defaultMessage: 'Resources',
    },
    identityResources: {
        id: 'sts-user-management-ui.identityResources',
        defaultMessage: 'Identity Resources',
    },
    apiResources: {
        id: 'sts-user-management-ui.protectedResources',
        defaultMessage: 'API Resources',
    },
    secrets: {
        id: 'sts-user-management-ui.secrets',
        defaultMessage: 'Secrets',
    },
    generateRandomClientId: {
        id: 'sts-user-management-ui.generateRandomClientId',
        defaultMessage: 'Generate Random Client ID',
    },
    displayUrl: {
        id: 'sts-user-management-ui.displayUrl',
        defaultMessage: 'Display URL',
    },
    logoUrl: {
        id: 'sts-user-management-ui.logoUrl',
        defaultMessage: 'Logo URL',
    },
    grantTypesManage: {
        id: 'sts-user-management-ui.grantTypesManage',
        defaultMessage: 'Grant Type Management',
    },
    sharedSecrets: {
        id: 'sts-user-management-ui.sharedSecrets',
        defaultMessage: 'Shared Secrets',
    },
    sharedSecret: {
        id: 'sts-user-management-ui.sharedSecret',
        defaultMessage: 'SharedSecret',
    },
    secretType: {
        id: 'sts-user-management-ui.secretType',
        defaultMessage: 'Secret Type',
    },
    type: {
        id: 'sts-user-management-ui.type',
        defaultMessage: 'Type',
    },
    value: {
        id: 'sts-user-management-ui.value',
        defaultMessage: 'Value',
    },
    addSharedSecret: {
        id: 'sts-user-management-ui.addSharedSecret',
        defaultMessage: 'Add Secret',
    },
    cancelProductHeader: {
        id: 'sts-user-management-ui.cancelProductHeader',
        defaultMessage: 'Cancel Product Changes',
    },
    cancelProductConfirm: {
        id: 'sts-user-management-ui.cancelProductConfirm',
        defaultMessage: 'There are unsaved changes. Are you sure you want to cancel making changes to this product?',
    },
    grantTypesDescription: {
        id: 'sts-user-management-ui.grantTypesDescription',
        defaultMessage: 'Assign the Grant Types allowed for this Connected App to communicate and request access.',
    },
    sharedSecretsDescription: {
        id: 'sts-user-management-ui.sharedSecretsDescription',
        defaultMessage:
            'Create and manage the shared secret for the Connected App to use.\n' +
            'Warning: the secret will only be visible once after creation and will need to be recreated if forgotten, lost or needs to be changed.',
    },
    apiResourcesDescription: {
        id: 'sts-user-management-ui.apiResourcesDescription',
        defaultMessage: 'Assign the API Resources to which this Connected App will have access.',
    },
    expirationDate: {
        id: 'sts-user-management-ui.expirationDate',
        defaultMessage: 'Expiration Date',
    },
    expirationTime: {
        id: 'sts-user-management-ui.expirationTime',
        defaultMessage: 'Expiration Time',
    },
    expiration: {
        id: 'sts-user-management-ui.expiration',
        defaultMessage: 'Expiration',
    },
    addSecret: {
        id: 'sts-user-management-ui.addSecret',
        defaultMessage: 'ADD SECRET',
    },
    warningSecretValue: {
        id: 'sts-user-management-ui.warningSecretValue',
        defaultMessage: 'WARNING: You will not be able to access the value of this secret after adding it.',
    },
    deleteSecret: {
        id: 'sts-user-management-ui.deleteSecret',
        defaultMessage: 'Delete Secret',
    },
    generateRandomValue: {
        id: 'sts-user-management-ui.generateRandomValue',
        defaultMessage: 'Generate Random Value',
    },
    uris: {
        id: 'sts-user-management-ui.uris',
        defaultMessage: 'URIs',
    },
    finish: {
        id: 'sts-user-management-ui.finish',
        defaultMessage: 'FINISH',
    },
    confirmApplicationDetails: {
        id: 'sts-user-management-ui.confirmApplicationDetails',
        defaultMessage: 'Confirm Application Details',
    },
    failedAddApplication: {
        id: 'sts-user-management-ui.failedAddApplication',
        defaultMessage:
            'We couldn’t save application right now. Please try again or refresh the page if this persists.',
    },
    applicationAdded: {
        id: 'sts-user-management-ui.applicationAdded',
        defaultMessage: 'Application Added',
    },
    failedUpdateApplication: {
        id: 'sts-user-management-ui.failedUpdateApplication',
        defaultMessage:
            'We couldn’t update application right now. Please try again or refresh the page if this persists.',
    },
    applicationUpdated: {
        id: 'sts-user-management-ui.applicationUpdated',
        defaultMessage: 'Application Updated',
    },
    cancelApplicationCreation: {
        id: 'sts-user-management-ui.cancelApplicationCreation',
        defaultMessage: 'Cancel Application Creation',
    },
    cancelApplicationCreationConfirmation: {
        id: 'sts-user-management-ui.cancelApplicationCreationConfirmation',
        defaultMessage: 'Are you sure you want to cancel creating this application?',
    },
    ok: {
        id: 'sts-user-management-ui.ok',
        defaultMessage: 'OK',
    },
    softwareId: {
        id: 'sts-user-management-ui.softwareId',
        defaultMessage: 'Software ID',
    },
    advanced: {
        id: 'sts-user-management-ui.advanced',
        defaultMessage: 'Advanced',
    },
    identityTokenLifetime: {
        id: 'sts-user-management-ui.identityTokenLifetime',
        defaultMessage: 'Identity Token Lifetime (Seconds)',
    },
    accessTokenLifetime: {
        id: 'sts-user-management-ui.accessTokenLifetime',
        defaultMessage: 'Access Token Lifetime (Seconds)',
    },
    authorizationCodeLifetime: {
        id: 'sts-user-management-ui.authorizationCodeLifetime',
        defaultMessage: 'Authorization Token Lifetime (Seconds)',
    },
    consentLifetime: {
        id: 'sts-user-management-ui.consentLifetime',
        defaultMessage: 'Consent Token Lifetime (Seconds)',
    },
    SSOLifetime: {
        id: 'sts-user-management-ui.SSOLifetime',
        defaultMessage: 'SSO Lifetime (Seconds)',
    },
    lifetimeTooShort: {
        id: 'sts-user-management-ui.lifetimeTooShort',
        defaultMessage: 'Lifetime must be at least 300 seconds',
    },
    addProperty: {
        id: 'sts-user-management-ui.addProperty',
        defaultMessage: 'Add Property',
    },
    deleteProperty: {
        id: 'sts-user-management-ui.deleteProperty',
        defaultMessage: 'Delete Property',
    },
    properties: {
        id: 'sts-user-management-ui.properties',
        defaultMessage: 'Properties',
    },
    propertyKeyAlreadyExists: {
        id: 'sts-user-management-ui.propertyKeyAlreadyExists',
        defaultMessage: 'Property Key already exists',
    },
    tokens: {
        id: 'sts-user-management-ui.tokens',
        defaultMessage: 'Tokens',
    },
    claims: {
        id: 'sts-user-management-ui.claims',
        defaultMessage: 'Claims',
    },
    grantTypes: {
        id: 'sts-user-management-ui.grantTypes',
        defaultMessage: 'Grant Types',
    },
    restrictions: {
        id: 'sts-user-management-ui.restrictions',
        defaultMessage: 'Restrictions',
    },
    key: {
        id: 'sts-user-management-ui.key',
        defaultMessage: 'Key',
    },
    addClaim: {
        id: 'sts-user-management-ui.addClaim',
        defaultMessage: 'Add Claim',
    },
    deleteClaim: {
        id: 'sts-user-management-ui.deleteClaim',
        defaultMessage: 'Delete Claim',
    },
    claimTypeAlreadyExists: {
        id: 'sts-user-management-ui.claimTypeAlreadyExists',
        defaultMessage: 'Claim Type already exists',
    },
    cancelApplicationChanges: {
        id: 'sts-user-management-ui.cancelApplicationChanges',
        defaultMessage: 'Cancel Application Changes',
    },
    cancelApplicationChangesConfirmation: {
        id: 'sts-user-management-ui.cancelApplicationChangesConfirmation',
        defaultMessage: 'Are you sure you want to cancel making changes to this application?',
    },
    addGrantType: {
        id: 'sts-user-management-ui.addGrantType',
        defaultMessage: 'Add Grant Type',
    },
    deleteGrantType: {
        id: 'sts-user-management-ui.deleteGrantType',
        defaultMessage: 'Delete Grant Type',
    },
    allowedUsers: {
        id: 'sts-user-management-ui.allowedUsers',
        defaultMessage: 'Allowed Users',
    },
    addUriTip: {
        id: 'sts-user-management-ui.addUriTip',
        defaultMessage: 'Add URI',
    },
    deleteUri: {
        id: 'sts-user-management-ui.deleteUri',
        defaultMessage: 'Delete URI',
    },
    uri: {
        id: 'sts-user-management-ui.uri',
        defaultMessage: 'URI',
    },
    origin: {
        id: 'sts-user-management-ui.origin',
        defaultMessage: 'Origin',
    },
    addOrigin: {
        id: 'sts-user-management-ui.addOrigin',
        defaultMessage: 'Add Origin',
    },
    deleteOrigin: {
        id: 'sts-user-management-ui.deleteOrigin',
        defaultMessage: 'Delete Origin',
    },
    otherUris: {
        id: 'sts-user-management-ui.otherUris',
        defaultMessage: 'Other URIs',
    },
    initiateLoginUri: {
        id: 'sts-user-management-ui.initiateLoginUri',
        defaultMessage: 'Initiate Login URI',
    },
    tosUri: {
        id: 'sts-user-management-ui.tosUri',
        defaultMessage: 'Terms of Service URI',
    },
    policyUri: {
        id: 'sts-user-management-ui.policyUri',
        defaultMessage: 'Policy URI',
    },
    configureSoftwareIds: {
        id: 'sts-user-management-ui.configureSoftwareIds',
        defaultMessage: 'Configure Software IDs',
    },
    addSoftwareId: {
        id: 'sts-user-management-ui.addSoftwareId',
        defaultMessage: 'Add Software ID',
    },
    editSoftwareId: {
        id: 'sts-user-management-ui.editSoftwareId',
        defaultMessage: 'Edit Software ID',
    },
    deleteSoftwareId: {
        id: 'sts-user-management-ui.deleteSoftwareId',
        defaultMessage: 'Delete Software ID',
    },
    softwareIdUpdated: {
        id: 'sts-user-management-ui.softwareIdUpdated',
        defaultMessage: 'Software ID updated',
    },
    deleteSoftwareIdConfirmation: {
        id: 'sts-user-management-ui.deleteSoftwareIdConfirmation',
        defaultMessage: 'Delete the selected Software ID(s)?',
    },
    failedDeleteSoftwareId: {
        id: 'sts-user-management-ui.failedDeleteSoftwareId',
        defaultMessage: 'Failed to Software ID',
    },
    failedGetSoftwareIds: {
        id: 'sts-user-management-ui.failedGetSoftwareIds',
        defaultMessage:
            'We couldn’t fetch all Software IDs right now. Please try again or refresh the page if this persists.',
    },
    failedCreateSoftwareId: {
        id: 'sts-user-management-ui.failedCreateSoftwareId',
        defaultMessage:
            'We couldn’t save Software ID right now. Please try again or refresh the page if this persists.',
    },
    failedUpdateSoftwareId: {
        id: 'sts-user-management-ui.failedUpdateSoftwareId',
        defaultMessage:
            'We couldn’t update Software ID right now. Please try again or refresh the page if this persists.',
    },
    authentication: {
        id: 'sts-user-management-ui.authentication',
        defaultMessage: 'Authentication',
    },
    authenticationNoProviders: {
        id: 'sts-user-management-ui.authenticationNoProviders',
        defaultMessage: 'No identity providers',
    },
    authenticationNoProvidersDetail: {
        id: 'sts-user-management-ui.authenticationNoProvidersDetail',
        defaultMessage: 'Let users log in through services like Azure Active Directory',
    },
    authenticationAddProvider: {
        id: 'sts-user-management-ui.authenticationAddProvider',
        defaultMessage: 'ADD A PROVIDER',
    },

    authenticationFailedGetLoginProviders: {
        id: 'sts-user-management-ui.authenticationFailedGetLoginProviders',
        defaultMessage: 'We couldn’t fetch all the login providers right now. Please refresh the page and try again.',
    },
    failedGetExternalMfa: {
        id: 'sts-user-management-ui.failedGetExternalMfa',
        defaultMessage: "Oops! It looks like we weren't able to retrieve your MFA details.",
    },
    authenticationFailedCreateLoginProvider: {
        id: 'sts-user-management-ui.authenticationFailedCreateLoginProvider',
        defaultMessage:
            'We couldn’t create the login provider right now. Please try again or refresh the page if this persists.',
    },
    authenticationFailedIdPLoginProvider: {
        id: 'sts-user-management-ui.authenticationFailedIdPLoginProvider',
        defaultMessage:
            'We couldn’t configure the login provider right now. Kindly ensure that you have entered valid details and try again.',
    },
    failedCreateMfa: {
        id: 'sts-user-management-ui.failedCreateMfa',
        defaultMessage:
            'We couldn’t create the external MFA provider right now. Please try again or refresh the page if this persists.',
    },
    mfaAdded: {
        id: 'sts-user-management-ui.mfaAdded',
        defaultMessage: "You've successfully added a new DUO Multi-Factor authentication provider!",
    },
    authenticationFailedUpdateLoginProviderUsers: {
        id: 'sts-user-management-ui.authenticationFailedUpdateLoginProviderUsers',
        defaultMessage:
            'We couldn’t update the login provider right now. Please try again or refresh the page if this persists.',
    },
    authenticationFailedUpdateLoginProvider: {
        id: 'sts-user-management-ui.authenticationFailedUpdateLoginProvider',
        defaultMessage:
            'We couldn’t update the login provider right now. Please try again or refresh the page if this persists.',
    },
    authenticationFailedDeleteLoginProvider: {
        id: 'sts-user-management-ui.authenticationFailedDeleteLoginProvider',
        defaultMessage:
            'We couldn’t delete the login provider right now. Please try again or refresh the page if this persists.',
    },
    disableProviderDisclaimer: {
        id: 'sts-user-management-ui.disableProviderDisclaimer',
        defaultMessage: 'Are you sure you want to disable this Authentication Provider?',
    },
    authenticationDisableWarning: {
        id: 'sts-user-management-ui.authenticationDisableWarning',
        defaultMessage:
            'Disabling this authentication method will disable the users. Are you sure you want to disable?',
    },

    // Authentication / Add Identity Provider Dialog
    authenticationProviderAdded: {
        id: 'sts-user-management-ui.authenticationProviderAdded',
        defaultMessage: "You've successfully added a new login provider!",
    },
    authenticationAddProviderDialogHeader: {
        id: 'sts-user-management-ui.authenticationAddProviderDialogHeader',
        defaultMessage: 'Add Identity Provider',
    },
    authenticationAddProviderDialogLabelDisplayName: {
        id: 'sts-user-management-ui.authenticationAddProviderDialogLabelDisplayName',
        defaultMessage: 'Display Name',
    },
    authenticationAddProviderDialogLabelClientId: {
        id: 'sts-user-management-ui.authenticationAddProviderDialogLabelClientId',
        defaultMessage: 'Client ID',
    },
    authenticationAddProviderDialogSubLabel: {
        id: 'sts-user-management-ui.authenticationAddProviderDialogSubLabel',
        defaultMessage: 'Your identity provider should have this',
    },
    authenticationAddProviderDialogLabelAuthorityUrl: {
        id: 'sts-user-management-ui.authenticationAddProviderDialogLabelAuthorityUrl',
        defaultMessage: 'Authority URL',
    },
    authenticationAddProviderDialogLabelResponseType: {
        id: 'sts-user-management-ui.authenticationAddProviderDialogLabelResponseType',
        defaultMessage: 'Response Type',
    },
    authenticationAddProviderDialogResponseTypeSubLabel: {
        id: 'sts-user-management-ui.authenticationAddProviderDialogResponseTypeSubLabel',
        defaultMessage:
            'For most Identity Providers, the default response type is id_token. Only change this setting if your identity provider does not support the id_token response type (ex: Crm).',
    },
    authenticationAddProviderDialogLabelDescription: {
        id: 'sts-user-management-ui.authenticationAddProviderDialogLabelDescription',
        defaultMessage: 'Description',
    },
    authenticationAddProviderDialogLabelRedirectUri: {
        id: 'sts-user-management-ui.authenticationAddProviderDialogLabelRedirectUri',
        defaultMessage: 'Redirect URI',
    },
    authenticationAddProviderDialogLabelSignouttUri: {
        id: 'sts-user-management-ui.authenticationAddProviderDialogLabelSignouttUri',
        defaultMessage: 'Logout URI',
    },
    authenticationTestConfiguration: {
        id: 'sts-user-management-ui.authenticationTestConfiguration',
        defaultMessage: 'Test Configuration',
    },
    authenticationTestConfigurationValid: {
        id: 'sts-user-management-ui.authenticationTestConfigurationValid',
        defaultMessage: 'Valid identity provider configuration!',
    },
    authenticationTestConfigurationInvalid: {
        id: 'sts-user-management-ui.authenticationTestConfigurationInvalid',
        defaultMessage: 'Identity provider configuration not valid.',
    },
    authenticationUsersListTitle: {
        id: 'sts-user-management-ui.authenticationUsersListTitle',
        defaultMessage: 'Select which users will use this authentication method',
    },

    // Authentication / Edit Identity Provider Dialog

    authenticationEditProviderSuccessfully: {
        id: 'sts-user-management-ui.authenticationEditProviderSuccessfully',
        defaultMessage: 'Provider is Updated',
    },
    authenticationEditProviderDialogTitle: {
        id: 'sts-user-management-ui.authenticationEditProviderDialogTitle',
        defaultMessage: 'Edit Identity Provider',
    },
    next: {
        id: 'sts-user-management-ui.next',
        defaultMessage: 'Next',
    },
    authenticationEditProviderDialogManageRemovedUsersTitle: {
        id: 'sts-user-management-ui.authenticationEditProviderDialogManageRemovedUsersTitle',
        defaultMessage: 'Manage Removed Users',
    },
    authenticationEditProviderDialogManageRemovedUsersDescription: {
        id: 'sts-user-management-ui.authenticationEditProviderDialogManageRemovedUsersDescription',
        defaultMessage:
            'Users who will be removed from this identity provider must be added to a new identity provider, deleted, disabled or enabled to use local login.',
    },
    authenticationEditProviderDialogEnableLocalLogin: {
        id: 'sts-user-management-ui.authenticationEditProviderDialogEnableLocalLogin',
        defaultMessage: 'Enable local login for users',
    },
    authenticationEditProviderDialogDisableUsers: {
        id: 'sts-user-management-ui.authenticationEditProviderDialogDisableUsers',
        defaultMessage: 'Disable users',
    },
    authenticationEditProviderDialogDeleteUsers: {
        id: 'sts-user-management-ui.authenticationEditProviderDialogDeleteUsers',
        defaultMessage: 'Delete users',
    },
    authenticationEditProviderDialogMoveUsers: {
        id: 'sts-user-management-ui.authenticationEditProviderDialogMoveUsers',
        defaultMessage: 'Associate users to a different identity provider',
    },
    enableLocalLoginTextMessage: {
        id: 'sts-user-management-ui.enableLocalLoginTextMessage',
        defaultMessage: 'Sends a password reset email to all users associated to the identity provider.',
    },
    disableUsersTextMessage: {
        id: 'sts-user-management-ui.disableUsersTextMessage',
        defaultMessage: 'Disables users who are being removed from this identity provider.',
    },
    deleteUsersTextMessage: {
        id: 'sts-user-management-ui.deleteUsersTextMessage',
        defaultMessage: 'Deletes users who are being removed from this login provider.',
    },
    changeLoginProviderTextMessage: {
        id: 'sts-user-management-ui.changeLoginProviderTextMessage',
        defaultMessage: 'Assigns all users to selected identity provider.',
    },
    authenticationDetails: {
        id: 'sts-user-management-ui.authenticationDetails',
        defaultMessage: 'Authentication Details',
    },

    // Authentication / Delete Identity Provider Dialog

    authenticationDeleteProviderDialogHeader: {
        id: 'sts-user-management-ui.authenticationDeleteProviderDialogHeader',
        defaultMessage: 'Delete Provider',
    },
    authenticationDeleteProviderDialogDescription: {
        id: 'sts-user-management-ui.authenticationDeleteProviderDialogDescription',
        defaultMessage:
            'Deleting this provider will prevent users from logging in to the ConnectWise Partner Portal or any associated ConnectWise products. The affected users must be added to a new identity provider or a local login must be enabled.',
    },
    clientName: {
        id: 'sts-user-management-ui.clientName',
        defaultMessage: 'ClientName',
    },
    addProvider: {
        id: 'sts-user-management-ui.addProvider',
        defaultMessage: 'Add Provider',
    },
    addLoginHeaderProvider: {
        id: 'sts-user-management-ui.addLoginHeaderProvider',
        defaultMessage: 'Add Login Provider',
    },
    editProvider: {
        id: 'sts-user-management-ui.editProvider',
        defaultMessage: 'Edit Login Provider',
    },
    enableProvider: {
        id: 'sts-user-management-ui.enableProvider',
        defaultMessage: 'Enable Login Provider',
    },
    disableProvider: {
        id: 'sts-user-management-ui.disableProvider',
        defaultMessage: 'Disable Login Provider',
    },
    deleteProvider: {
        id: 'sts-user-management-ui.deleteProvider',
        defaultMessage: 'Delete Login Provider',
    },
    clientIdInfotext: {
        id: 'sts-user-management-ui.clientIdInfotext',
        defaultMessage: 'Your identity provider should have this',
    },
    authorityInfotext: {
        id: 'sts-user-management-ui.authorityInfotext',
        defaultMessage: 'Your identity provider should have this',
    },
    responseTypeInfotext: {
        id: 'sts-user-management-ui.responseTypeInfotext',
        defaultMessage:
            'For most Identity Providers, the default response type is id_token. Only change this setting if your identity provider does not support the id_token response type (ex: Crm).',
    },
    loginProviderDeleted: {
        id: 'sts-user-management-ui.loginProviderDeleted',
        defaultMessage: 'Authentication method deleted.',
    },
    deleteAuthMethod: {
        id: 'sts-user-management-ui.deleteAuthMethod',
        defaultMessage: 'Delete Authentication Method',
    },
    deleteAuthMethodConfirmation: {
        id: 'sts-user-management-ui.deleteAuthMethodConfirmation',
        defaultMessage: 'Are you sure you want to delete?',
    },
    disableAuthMethod: {
        id: 'sts-user-management-ui.disableAuthMethod',
        defaultMessage: 'Disable Authentication Method',
    },
    disableAuthMethodConfirmation: {
        id: 'sts-user-management-ui.disableAuthMethodConfirmation',
        defaultMessage:
            'Disabling this authentication method will disable the users. Are you sure you want to continue?',
    },
    disableDuoProviderConfirmation: {
        id: 'sts-user-management-ui.disableDuoProviderConfirmation',
        defaultMessage:
            'Are you sure you want to disable this MFA? If you do, please keep in mind that any assigned users with this MFA will not be able to log in.',
    },
    enableAuthMethod: {
        id: 'sts-user-management-ui.enableAuthMethod',
        defaultMessage: 'Enable Authentication Method',
    },
    enableAuthMethodConfirmation: {
        id: 'sts-user-management-ui.enableAuthMethodConfirmation',
        defaultMessage: 'Are you sure you want to enable this Authentication Provider?',
    },
    invalidAuthorityUrl: {
        id: 'sts-user-management-ui.invalidAuthorityUrl',
        defaultMessage: 'Test Configuration Failed',
    },
    successAuthorityUrl: {
        id: 'sts-user-management-ui.successAuthorityUrl',
        defaultMessage: 'Test Configuration was successful',
    },
    copyClipboard: {
        id: 'sts-user-management-ui.copyClipboard',
        defaultMessage: 'Copy Clipboard',
    },
    information: {
        id: 'sts-user-management-ui.information',
        defaultMessage: 'Information',
    },
    refresh: {
        id: 'sts-user-management-ui.refresh',
        defaultMessage: 'Refresh',
    },
    copyClipboardMessage: {
        id: 'sts-user-management-ui.copyClipboardMessage',
        defaultMessage: '{data} copied to clipboard!',
    },
    addRolesText: {
        id: 'sts-user-management-ui.addRolesText',
        defaultMessage: 'Select roles from below and click the up arrow to add.',
    },
    createRole: {
        id: 'sts-user-management-ui.createRole',
        defaultMessage: 'Create a New Role',
    },
    roleInformation: {
        id: 'sts-user-management-ui.roleInformation',
        defaultMessage: 'Role Information',
    },
    createRoleDesc: {
        id: 'sts-user-management-ui.createRoleDesc',
        defaultMessage:
            'Add a name and description for the role that fits the role of the user to which it will be applied.',
    },
    editRoleDesc: {
        id: 'sts-user-management-ui.editRoleDesc',
        defaultMessage:
            'Edit a name and description for the role that fits the role of the user to which it will be applied.',
    },
    linkToRole: {
        id: 'sts-user-management-ui.linkToRole',
        defaultMessage: 'Connected App Access',
    },
    linkToRoleDesc: {
        id: 'sts-user-management-ui.linkToRoleDesc',
        defaultMessage:
            'Listed below are ConnectWise applications connected to your account. Click the Add (+) button to add a specific application role to your identity role.',
    },
    addRoleDrawerTitle: {
        id: 'sts-user-management-ui.addRoleDrawerTitle',
        defaultMessage: 'Add Identity Role',
    },
    createRoleSubHeader: {
        id: 'sts-user-management-ui.createRoleSubHeader',
        defaultMessage:
            'Create an identity role to define an identity with multiple access levels you want to assign to users ',
    },
    editRoleSubHeader: {
        id: 'sts-user-management-ui.editRoleSubHeader',
        defaultMessage: 'Edit a role with assigned access to a user for your Connected Apps',
    },
    roleName: {
        id: 'sts-user-management-ui.roleName',
        defaultMessage: 'Role Name',
    },
    createButton: {
        id: 'sts-user-management-ui.createButton',
        defaultMessage: 'CREATE',
    },
    successCreateRole: {
        id: 'sts-user-management-ui.successCreateRole',
        defaultMessage: 'Your role has been created successfully.',
    },
    userCountErrorMsg: {
        id: 'sts-user-management-ui.userCountErrorMsg',
        defaultMessage:
            'We couldn’t delete this role. All users must be removed from this role before it can be deleted.',
    },
    roleDeleted: {
        id: 'sts-user-management-ui.roleDeleted',
        defaultMessage: 'Role deleted successfully',
    },
    createRoleSubText: {
        id: 'sts-user-management-ui.createRoleSubText',
        defaultMessage: '### Sub Title ###',
    },
    editDefaultRole: {
        id: 'sts-user-management-ui.editDefaultRole',
        defaultMessage: 'The default SSO roles are not editable.',
    },
    roleUsersListTitle: {
        id: 'sts-user-management-ui.roleUsersListTitle',
        defaultMessage: 'Select which users will be assigned this role',
    },
    failedLoadConnectedApps: {
        id: 'sts-user-management-ui.failedLoadConnectedApps',
        defaultMessage:
            'We couldn’t fetch all the connected apps right now. Please try again or refresh the page if this persists.',
    },
    mfaOn: {
        id: 'sts-user-management-ui.mfaOn',
        defaultMessage: 'Multi-Factor Authentication is turned on',
    },
    mfaOff: {
        id: 'sts-user-management-ui.mfaOff',
        defaultMessage: 'Multi-Factor Authentication is turned off',
    },
    deleteAccount: {
        id: 'sts-user-management-ui.deleteAccount',
        defaultMessage: 'Delete User',
    },
    downloadUserList: {
        id: 'sts-user-management-ui.downloadUserList',
        defaultMessage: 'Download User List',
    },
    mfaForget: {
        id: 'sts-user-management-ui.mfaForget',
        defaultMessage: 'Forget MFA',
    },
    mfaUpdate: {
        id: 'sts-user-management-ui.mfaUpdate',
        defaultMessage: 'Update MFA',
    },
    failedToGetValidMfaProvidersMessage: {
        id: 'sts-user-management-ui.failedToGetValidMfaProvidersMessage',
        defaultMessage: 'Something went wrong to get the valid MFA providers',
    },
    emailMfaForgotten: {
        id: 'sts-user-management-ui.emailMfaForgotten',
        defaultMessage: 'Email MFA is disabled for this user',
    },
    failedToDisableEmailMfa: {
        id: 'sts-user-management-ui.failedToDisableEmailMfa',
        defaultMessage: 'Something went wrong when tried to Disable Email MFA for this user',
    },
    authAppMfaForgotten: {
        id: 'sts-user-management-ui.authAppMfaForgotten',
        defaultMessage: 'Auth app MFA settings reset done successfully.',
    },
    failedToDisableAuthAppMfa: {
        id: 'sts-user-management-ui.failedToDisableAuthAppMfa',
        defaultMessage:
            'The Auth MFA is already reset. While logging in, the user should either scan the QR code or add the secret key to the authenticator app.',
    },
    setAuthMethod: {
        id: 'sts-user-management-ui.setAuthMethod',
        defaultMessage: 'Set Authentication Method',
    },
    setAuthMethodDialogHeader: {
        id: 'sts-user-management-ui.setAuthMethodDialogHeader',
        defaultMessage: 'Select Authentication Method',
    },
    updateMandatoryMfa: {
        id: 'sts-user-management-ui.updateMandatoryMfa',
        defaultMessage: 'Update Mandatory MFA',
    },
    userSettingLabel: {
        id: 'sts-user-management-ui.userSettingLabel',
        defaultMessage: 'USER SETTINGS',
    },
    permissions: {
        id: 'sts-user-management-ui.permissions',
        defaultMessage: 'Permissions',
    },
    clonePermissionsDesc: {
        id: 'sts-user-management-ui.clonePermissionsDesc',
        defaultMessage: 'You can assign custom permissions to this role as per your needs.',
    },
    security: {
        id: 'sts-user-management-ui.security',
        defaultMessage: 'Security',
    },
    selectMethod: {
        id: 'sts-user-management-ui.selectMethod',
        defaultMessage: 'Select a method',
    },
    apply: {
        id: 'sts-user-management-ui.apply',
        defaultMessage: 'Apply',
    },
    authMethodConfirmation: {
        id: 'sts-user-management-ui.authMethodConfirmation',
        defaultMessage: 'Choose which authentication method you would like to apply to the selected users.',
    },
    updateMfaDesc: {
        id: 'sts-user-management-ui.updateMfaDesc',
        defaultMessage: 'Select the preferred MFA operation and MFA method for the selected users.',
    },
    updateMfaAddDesc: {
        id: 'sts-user-management-ui.updateMfaAddDesc',
        defaultMessage: 'MFA methods applied will be enabled for the selected users.',
    },
    updateMfaRemoveDesc: {
        id: 'sts-user-management-ui.updateMfaRemoveDesc',
        defaultMessage: 'MFA methods applied will be disabled for the selected users.',
    },
    selectMfaMethod: {
        id: 'sts-user-management-ui.selectMfaMethod',
        defaultMessage: 'Select MFA method',
    },
    addMfa: {
        id: 'sts-user-management-ui.addMfa',
        defaultMessage: 'Add MFA',
    },
    removeMfa: {
        id: 'sts-user-management-ui.removeMfa',
        defaultMessage: 'Remove MFA',
    },
    successBulkUpdateMfa: {
        id: 'sts-user-management-ui.successBulkUpdateMfa',
        defaultMessage: 'MFA configuration for {userCount} user(s) updated successfully.',
    },
    partialSuccessBulkUpdateMfa: {
        id: 'sts-user-management-ui.partialSuccessBulkUpdateMfa',
        defaultMessage:
            'MFA configuration updated partially. Unable to update the MFA configuration for {userCount} user(s). Please try again.',
    },
    errorBulkUpdateMfa: {
        id: 'sts-user-management-ui.errorBulkUpdateMfa',
        defaultMessage: 'MFA configuration update failed. Please try again.',
    },
    selectRole: {
        id: 'sts-user-management-ui.selectRole',
        defaultMessage: 'Select an Identity Role',
    },
    updateRoleDialogHeader: {
        id: 'sts-user-management-ui.updateRoleDialogHeader',
        defaultMessage: 'Update Assigned Identity Role',
    },
    updateRoleDialogDercription: {
        id: 'sts-user-management-ui.updateAssignedRole',
        defaultMessage: 'Choose which identity role you would like to remove for the selected users.',
    },
    selectApplication: {
        id: 'sts-user-management-ui.selectApplication',
        defaultMessage: 'Select an application',
    },
    updateApplicationDialogHeader: {
        id: 'sts-user-management-ui.updateApplicationDialogHeader',
        defaultMessage: 'Update Application Access',
    },
    updateApplicationDialogDescription: {
        id: 'sts-user-management-ui.updateApplicationDialogDescription',
        defaultMessage: 'Choose which product you would like to add or remove access for the selected users.',
    },
    manageRole: {
        id: 'sts-user-management-ui.manageRole',
        defaultMessage: 'User Roles',
    },
    addIdentityRole: {
        id: 'sts-user-management-ui.addIdentityRole',
        defaultMessage: 'Add Identity Role',
    },
    removeIdentityRole: {
        id: 'sts-user-management-ui.removeIdentityRole',
        defaultMessage: 'Remove Identity Role',
    },
    manageApplication: {
        id: 'sts-user-management-ui.manageApplication',
        defaultMessage: 'Application Access',
    },
    token: {
        id: 'sts-user-management-ui.token',
        defaultMessage: 'Token',
    },
    instanceEdit: {
        id: 'sts-user-management-ui.instanceEdit',
        defaultMessage: 'Product Instance Updated Successfully',
    },
    addURIInfoText: {
        id: 'sts-user-management-ui.addURIInfoText',
        defaultMessage:
            'Less than 256 characters. No wildcard characters. No query strings. Must be a valid URI starting with https.',
    },
    importedUserEmailText: {
        id: 'sts-user-management-ui.importedUserEmailText',
        defaultMessage: 'Enter the email this user will use to login to ConnectWise SSO',
    },
    create: {
        id: 'sts-user-management-ui.create',
        defaultMessage: 'Create',
    },
    optional: {
        id: 'sts-user-management-ui.optional',
        defaultMessage: '*Optional',
    },
    enterName: {
        id: 'sts-user-management-ui.enterName',
        defaultMessage: 'Enter name',
    },
    enterRoleName: {
        id: 'sts-user-management-ui.enterRoleName',
        defaultMessage: 'Enter role name',
    },
    enterDescription: {
        id: 'sts-user-management-ui.enterDescription',
        defaultMessage: 'Enter Description',
    },
    enterRoleDescription: {
        id: 'sts-user-management-ui.enterRoleDescription',
        defaultMessage: 'Enter role description',
    },
    enterDisplayName: {
        id: 'sts-user-management-ui.enterDisplayName',
        defaultMessage: 'Enter Display Name',
    },
    enterBackChannelLogoutUri: {
        id: 'sts-user-management-ui.enterBackChannelLogoutUri',
        defaultMessage: 'Enter backchannel logout URI',
    },
    enterFrontChannelLogoutUri: {
        id: 'sts-user-management-ui.enterFrontChannelLogoutUri',
        defaultMessage: 'Enter frontchannel logout URI',
    },
    enterFirstName: {
        id: 'sts-user-management-ui.enterFirstName',
        defaultMessage: 'Enter first name',
    },
    enterLastName: {
        id: 'sts-user-management-ui.enterLastName',
        defaultMessage: 'Enter last name',
    },
    enterMiddleName: {
        id: 'sts-user-management-ui.enterMiddleName',
        defaultMessage: 'Enter middle name',
    },
    enterEmail: {
        id: 'sts-user-management-ui.enterEmail',
        defaultMessage: 'Enter email',
    },
    enterClientId: {
        id: 'sts-user-management-ui.enterClientId',
        defaultMessage: 'Enter client ID',
    },
    enterAuthorityURL: {
        id: 'sts-user-management-ui.enterAuthorityURL',
        defaultMessage: 'Enter authority URL',
    },
    enterRedirectURI: {
        id: 'sts-user-management-ui.enterRedirectURI',
        defaultMessage: 'Enter redirect URI',
    },
    enterLogoutURI: {
        id: 'sts-user-management-ui.enterLogoutURI',
        defaultMessage: 'Enter logout URI',
    },
    resetPasswordDisabledHint: {
        id: 'sts-user-management-ui.resetPasswordHint',
        defaultMessage: 'Reset password is only available when using the local login method.',
    },
    rolesDetails: {
        id: 'sts-user-management-ui.rolesDetails',
        defaultMessage: 'Role Details',
    },
    productDetails: {
        id: 'sts-user-management-ui.productDetails',
        defaultMessage: 'Product Details',
    },
    productUsersListTitle: {
        id: 'sts-user-management-ui.productUsersListTitle',
        defaultMessage: 'Select which users will have access to this product',
    },
    failedGetDisplayName: {
        id: 'sts-user-management-ui.failedGetDisplayName',
        defaultMessage: 'Display Name cannot be empty',
    },
    rolesUpdated: {
        id: 'sts-user-management-ui.rolesUpdated',
        defaultMessage: 'User Roles Updated',
    },
    accountDetails: {
        id: 'sts-user-management-ui.accountDetails',
        defaultMessage: 'Account Details',
    },
    accountDetailsDesc: {
        id: 'sts-user-management-ui.accountDetailsDesc',
        defaultMessage: 'Add user account details that will be used to login across connected apps.',
    },
    editAccountDetailsDesc: {
        id: 'sts-user-management-ui.editAccountDetailsDesc',
        defaultMessage: 'Edit user account details that will be used to login across connected apps.',
    },
    contactInformation: {
        id: 'sts-user-management-ui.contactInformation',
        defaultMessage: 'Contact Information',
    },
    connectWiseLoginEmail: {
        id: 'sts-user-management-ui.connectWiseLoginEmail',
        defaultMessage: 'ConnectWise Login Email',
    },
    emailDeliveryDisclaimerText: {
        id: 'sts-user-management-ui.emailDeliveryDisclaimerText',
        defaultMessage: 'The SSO activation email will not be delivered if the login email is invalid or nonexistent.',
    },
    emailVerified: {
        id: 'sts-user-management-ui.emailVerified',
        defaultMessage: 'Email Verified',
    },
    emailUnverified: {
        id: 'sts-user-management-ui.emailUnverified',
        defaultMessage: 'Email Unverified',
    },
    emailValid: {
        id: 'sts-user-management-ui.emailValid',
        defaultMessage: 'Valid email address.',
    },
    emailInvalid: {
        id: 'sts-user-management-ui.emailInvalid',
        defaultMessage: 'Incorrect email address format.',
    },
    address1: {
        id: 'sts-user-management-ui.address1',
        defaultMessage: 'Address Location',
    },
    address2: {
        id: 'sts-user-management-ui.address2',
        defaultMessage: 'Address 2',
    },
    city: {
        id: 'sts-user-management-ui.city',
        defaultMessage: 'City',
    },
    state: {
        id: 'sts-user-management-ui.state',
        defaultMessage: 'State',
    },
    country: {
        id: 'sts-user-management-ui.country',
        defaultMessage: 'Country',
    },
    zipCode: {
        id: 'sts-user-management-ui.zipCode',
        defaultMessage: 'Zip Code',
    },
    enterAddressPlaceholder: {
        id: 'sts-user-management-ui.enterAddressPlaceholder',
        defaultMessage: 'Enter address location',
    },
    enterAddress2Placeholder: {
        id: 'sts-user-management-ui.enterAddress2Placeholder',
        defaultMessage: 'Enter address 2',
    },
    enterNamePlaceholder: {
        id: 'sts-user-management-ui.enterNamePlaceholder',
        defaultMessage: 'Enter name',
    },
    enterCityPlaceholder: {
        id: 'sts-user-management-ui.enterCityPlaceholder',
        defaultMessage: 'Enter city',
    },
    enterStatePlaceholder: {
        id: 'sts-user-management-ui.enterStatePlaceholder',
        defaultMessage: 'Enter state',
    },
    enterZipCodePlaceholder: {
        id: 'sts-user-management-ui.enterZipCodePlaceholder',
        defaultMessage: 'Enter zip',
    },
    enterCountry: {
        id: 'sts-user-management-ui.enterCountry',
        defaultMessage: 'Enter country',
    },
    contactEmail: {
        id: 'sts-user-management-ui.contactEmail',
        defaultMessage: 'Contact Email',
    },
    contactEmailsameAsLoginEmail: {
        id: 'sts-user-management-ui.contactEmailsameAsLoginEmail',
        defaultMessage: 'Make this email the same as login email',
    },
    duoUserNamesameAsLoginEmail: {
        id: 'sts-user-management-ui.duoUserNamesameAsLoginEmail',
        defaultMessage: 'Make this user name the same as the login email',
    },
    preferred: {
        id: 'sts-user-management-ui.preferred',
        defaultMessage: 'Preferred Phone',
    },
    direct: {
        id: 'sts-user-management-ui.direct',
        defaultMessage: 'Direct Phone',
    },
    mobile: {
        id: 'sts-user-management-ui.mobile',
        defaultMessage: 'Mobile Phone',
    },
    preferredNumberHintText: {
        id: 'sts-user-management-ui.preferredNumberHintText',
        defaultMessage: 'Enter preferred phone',
    },
    directNumberHintText: {
        id: 'sts-user-management-ui.directNumberHintText',
        defaultMessage: 'Enter direct phone',
    },
    mobileNumberHintText: {
        id: 'sts-user-management-ui.mobileNumberHintText',
        defaultMessage: 'Enter mobile phone',
    },
    loginEmailHintText: {
        id: 'sts-user-management-ui.loginEmailHintText',
        defaultMessage: 'Enter login email',
    },
    contactEmailHintText: {
        id: 'sts-user-management-ui.contactEmailHintText',
        defaultMessage: 'Enter contact email',
    },
    invalidEmailMessage: {
        id: 'sts-user-management-ui.invalidEmailMessage',
        defaultMessage: 'Please enter valid email',
    },
    ext: {
        id: 'sts-user-management-ui.ext',
        defaultMessage: 'Ext',
    },
    phoneExtension: {
        id: 'sts-user-management-ui.phoneExtension',
        defaultMessage: 'ext.',
    },
    fax: {
        id: 'sts-user-management-ui.fax',
        defaultMessage: 'fax',
    },
    cell: {
        id: 'sts-user-management-ui.cell',
        defaultMessage: 'cell',
    },
    createNewProfile: {
        id: 'sts-user-management-ui.createNewProfile',
        defaultMessage: 'Create New Profile',
    },
    matchTitleDescription: {
        id: 'sts-user-management-ui.matchTitleDescription',
        defaultMessage:
            'We have found the following matching profiles for the user in ConnectWise. You can either link the user to a matched profile or create a new profile. Linking the user will update user information with the information from the selected profile.',
    },
    foundMatches: {
        id: 'sts-user-management-ui.foundMatches',
        defaultMessage: `{userCount, plural, one {Found Match} many {# Found Matches} other {Found Matches}}`,
    },
    recommended: {
        id: 'sts-user-management-ui.recommended',
        defaultMessage: 'Recommended',
    },
    foundMatchesSubText: {
        id: 'sts-user-management-ui.foundMatchesSubText',
        defaultMessage:
            'We have found the following matching profiles for the user in Connectwise. You can either link the user to a matched profile or create a new user.Linking the user will update user information',
    },
    approve: {
        id: 'sts-user-management-ui.approve',
        defaultMessage: 'Approve',
    },
    back: {
        id: 'sts-user-management-ui.back',
        defaultMessage: 'Back',
    },
    importMatchContactTitle: {
        id: 'sts-user-management-ui.importMatchContactTitle',
        defaultMessage: `We have found matching profiles for {userCount} users in ConnectWise.`,
    },
    importMatchContactDescription: {
        id: 'sts-user-management-ui.importMatchContactDescription',
        defaultMessage:
            'To ensure your users have full access to ConnectWise University and other services like support tickets, please match these contacts now.',
    },
    skipContact: {
        id: 'sts-user-management-ui.skipContact',
        defaultMessage: 'Skip Matching For Now',
    },
    viewFoundMatches: {
        id: 'sts-user-management-ui.viewFoundMatches',
        defaultMessage: 'View Found Matches',
    },
    agreeUser: {
        id: 'sts-user-management-ui.agreeUser',
        defaultMessage: 'Click to agree user information is correct',
    },
    skipMatchingUser: {
        id: 'sts-user-management-ui.skipMatchingUser',
        defaultMessage: 'Skip Matching User',
    },
    verifyMatchedContactsForImportedusers: {
        id: 'sts-user-management-ui.verifyMatchedContactsForImportedusers',
        defaultMessage: 'Click to agree that the information provided is correct.',
    },
    cancelMatchedContactsText: {
        id: 'sts-user-management-ui.cancelMatchedContactsText',
        defaultMessage:
            'Users that do not have ConnectWise profiles will have limited access to the University. Are you sure you want to close this window?',
    },
    importSuccessMessage: {
        id: 'sts-user-management-ui.importSuccessMessage',
        defaultMessage: 'Congrats! You have successfully approved the Imported users',
    },
    continueImportUsers: {
        id: 'sts-user-management-ui.continueImportUsers',
        defaultMessage: 'Continue Approving Users',
    },
    userContactMatchInfo: {
        id: 'sts-user-management-ui.userContactMatchInfo',
        defaultMessage: 'An existing contact with matching contact email has been found.',
    },
    userUniversityInfo: {
        id: 'sts-user-management-ui.userUniversityInfo',
        defaultMessage:
            'This user will have no University access until you have set their First Name, Last Name, ConnectWise Login Email, and assigned a University app role.',
    },
    adminRoleErrorMessage: {
        id: 'sts-user-management-ui.adminRoleErrorMessage',
        defaultMessage: 'You do not have permission to make this change. Only Admins can update the Admin role.',
    },
    continue: {
        id: 'sts-user-management-ui.continue',
        defaultMessage: 'Continue',
    },
    checkingMatchedContactsText: {
        id: 'sts-user-management-ui.checkingMatchedContactsText',
        defaultMessage: 'One moment, we are verifying the approved users.',
    },
    applicationAccessUpdateSuccessful: {
        id: 'sts-user-management-ui.applicationAccessUpdateSuccessful',
        defaultMessage: 'The application access has been successfully updated',
    },
    RoleAssignmentUpdateSuccessful: {
        id: 'sts-user-management-ui.RoleAssignmentUpdateSuccessful',
        defaultMessage: 'The role assignment has been successfully updated',
    },
    NewRoleAssignmentUpdateSuccessful: {
        id: 'sts-user-management-ui.NewRoleAssignmentUpdateSuccessful',
        defaultMessage: 'Roles for {rolesCount} users updated successfully',
    },
    RoleAssignmentUpdateFailed: {
        id: 'sts-user-management-ui.RoleAssignmentUpdateFailed',
        defaultMessage: 'The role assignment has been failed to updated',
    },
    authenticationMethodAddedSuccessful: {
        id: 'sts-user-management-ui.authenticationMethodAddedSuccessful',
        defaultMessage: 'The authentication method has been successfully applied.',
    },
    authenticationMethodAddedFailed: {
        id: 'sts-user-management-ui.authenticationMethodAddedFailed',
        defaultMessage: 'The authentication method has been failed to apply.',
    },
    authenticationMethodDeleteError: {
        id: 'sts-user-management-ui.authenticationMethodDeleteError',
        defaultMessage: 'The authentication method has been failed to be deleted',
    },
    deleteProviderDisclaimer: {
        id: 'sts-user-management-ui.deleteProviderDisclaimer',
        defaultMessage: 'Users must be removed from login provider before it can be deleted',
    },
    authenticationMethodActionSuccessful: {
        id: 'sts-user-management-ui.authenticationMethodActionSuccessful',
        defaultMessage: 'The authentication method has been successfully {action}.',
    },
    authenticationMethodActionFailed: {
        id: 'sts-user-management-ui.authenticationMethodActionFailed',
        defaultMessage: 'The authentication method has been failed to {action}.',
    },
    productInstanceDeletedSuccessful: {
        id: 'sts-user-management-ui.productInstanceDeletedSuccessful',
        defaultMessage: 'The application has been successfully deleted',
    },
    productInstanceDeletedFailed: {
        id: 'sts-user-management-ui.productInstanceDeletedFailed',
        defaultMessage:
            'We couldn’t delete the product instance right now. Please try again or refresh the page if this persists.',
    },
    deleted: {
        id: 'sts-user-management-ui.deleted',
        defaultMessage: 'deleted',
    },
    enterResourceName: {
        id: 'sts-user-management-ui.enterResourceName',
        defaultMessage: 'Enter Resource Name',
    },
    enterUserName: {
        id: 'sts-user-management-ui.enterUserName',
        defaultMessage: 'Enter user name',
    },
    noAccessAssignment: {
        id: 'sts-user-management-ui.noAccessAssignment',
        defaultMessage: 'Access assignment is not available',
    },
    addAppRole: {
        id: 'sts-user-management-ui.addAppRole',
        defaultMessage: 'Add app role',
    },
    newAddAppRole: {
        id: 'sts-user-management-ui.newAddAppRole',
        defaultMessage: 'Add another role',
    },
    appRedirect: {
        id: 'sts-user-management-ui.appRedirect',
        defaultMessage: 'Redirect to app in new tab',
    },
    appRedirectDisabled: {
        id: 'sts-user-management-ui.appRedirectDisabled',
        defaultMessage: 'Redirect to app is not available',
    },
    noResourcesApplicable: {
        id: 'sts-user-management-ui.noResourcesApplicable',
        defaultMessage: 'No resources applicable',
    },
    resourceSelectPlaceholder: {
        id: 'sts-user-management-ui.resourceSelectPlaceholder',
        defaultMessage: 'Enter Resource/Site/Workstation name',
    },
    emptyResourceError: {
        id: 'sts-user-management-ui.emptyResourceError',
        defaultMessage: 'Please add resource/sites to the app role',
    },
    addAccessToAppError: {
        id: 'sts-user-management-ui.addAccessToAppError',
        defaultMessage: 'Add access to at least one app.',
    },
    failedAddAccess: {
        id: 'sts-user-management-ui.failedAddAccess',
        defaultMessage:
            'We couldn’t assign access to app right now. Please try again or refresh the page if this persists.',
    },
    editRoleSubTitle: {
        id: 'sts-user-management-ui.editRoleSubTitle',
        defaultMessage: 'Edit the role to add the users or update their access for Connected Apps',
    },
    editRoleDetailsSubHeader: {
        id: 'sts-user-management-ui.editRoleDetailsSubHeader',
        defaultMessage:
            'Edit Role name and description that better fits the role of the user to which it will be applied.',
    },
    editAssignedUsersSubHeader: {
        id: 'sts-user-management-ui.editAssignedUsersSubHeader',
        defaultMessage:
            'Add/Remove the users to give/revoke the access to the apps as per defined app roles and resources/sites (if applicable) defined under this role.',
    },
    editConnectedAppsSubHeader: {
        id: 'sts-user-management-ui.editConnectedAppsSubHeader',
        defaultMessage:
            "Add/Update/Remove the roles below to update assigned user's access permissions. Click on the gear icon near to app to navigate to application in new window and know more about app roles.",
    },
    failedConnectedApps: {
        id: 'sts-user-management-ui.failedConnectedApps',
        defaultMessage:
            'We couldn’t fetch all the connected apps right now. Please try again or refresh the page if this persists.',
    },
    connectedApps: {
        id: 'sts-user-management-ui.connectedApps',
        defaultMessage: 'Connected Apps',
    },
    addProfile: {
        id: 'sts-user-management-ui.addProfile',
        defaultMessage: 'Add User',
    },
    connectedAppAccess: {
        id: 'sts-user-management-ui.connectedAppAccess',
        defaultMessage: 'Connected App Access',
    },
    addProfileSubHeader: {
        id: 'sts-user-management-ui.addProfileSubHeader',
        defaultMessage: 'Create a new user and assign roles to give access to Connected Apps',
    },
    editProfileSubHeader: {
        id: 'sts-user-management-ui.editProfileSubHeader',
        defaultMessage: 'Edit a user and assign roles to give access to Connected Apps',
    },
    assignedRolesSubHeader: {
        id: 'sts-user-management-ui.assignedRolesSubHeader',
        defaultMessage:
            "Add the identity roles that need to be assigned to the users to give access to connected app's roles associated under those identity roles.",
    },
    assignedRolesPlaceholder: {
        id: 'sts-user-management-ui.assignedRolesPlaceholder',
        defaultMessage: 'Enter a Role',
    },
    addRoleUserAssignmentFailed: {
        id: 'sts-user-management-ui.addRoleUserAssignmentFailed',
        defaultMessage: 'Users assignment to the role was unsuccessful.',
    },
    addRoleAppAssignmentFailed: {
        id: 'sts-user-management-ui.addRoleAppAssignmentFailed',
        defaultMessage:
            'Roles saved successfully but app assignment for {appNames} failed. Please re-assign the failed connected apps.',
    },
    roleAlreadyAdded: {
        id: 'sts-user-management-ui.roleAlreadyAdded',
        defaultMessage: 'App role "{roleName}" is already added',
    },
    contactInformationDesc: {
        id: 'sts-user-management-ui.contactInformationDesc',
        defaultMessage: 'Add user contact details that can be used to connect with user.',
    },
    addUserConnectedAppsTitle: {
        id: 'sts-user-management-ui.addUserConnectedAppsTitle',
        defaultMessage:
            'Add the identity roles in assigned roles above to assign individual app roles. Alternatively, click the Add (+) button to add a specific application role access to user.',
    },
    noRoleAssigned: {
        id: 'sts-user-management-ui.noRoleAssigned',
        defaultMessage: 'No roles assigned',
    },
    licensesCountText: {
        id: 'sts-user-management-ui.licensesCountText',
        defaultMessage: '{unusedLicensesCount} license(s) available',
    },
    licensesUnavailableText: {
        id: 'sts-user-management-ui.licensesUnavailableText',
        defaultMessage: '0 License(s) available. Click on the Cart icon to add licenses.',
    },

    noLicensesError: {
        id: 'sts-user-management-ui.noLicensesError',
        defaultMessage: '0 license(s) available, You will be unable to add this role.',
    },

    licenses: {
        id: 'sts-user-management-ui.licenses',
        defaultMessage: 'Licenses',
    },
    buyLicense: {
        id: 'sts-user-management-ui.buyLicense',
        defaultMessage: 'Click here to buy more licenses.',
    },
    canNotBuyLicense: {
        id: 'sts-user-management-ui.canNotBuyLicense',
        defaultMessage: 'License cannot be bought at this moment.',
    },
    refreshAppDetails: {
        id: 'sts-user-management-ui.refreshAppDetails',
        defaultMessage: 'Click here to refresh details.',
    },
    inheritedFrom: {
        id: 'sts-user-management-ui.inheritedFrom',
        defaultMessage: 'Inherited from',
    },
    resource: {
        id: 'sts-user-management-ui.resource',
        defaultMessage: 'Resource',
    },
    accountInfo: {
        id: 'sts-user-management-ui.accountInfo',
        defaultMessage: 'Account Info',
    },
    enableAccount: {
        id: 'sts-user-management-ui.enableAccount',
        defaultMessage: 'Enable Account',
    },
    resetPasswordMessage: {
        id: 'sts-user-management-ui.resetPasswordMessage',
        defaultMessage: 'Are you sure you want to reset password for this user?',
    },
    resendInviteMessage: {
        id: 'sts-user-management-ui.resendInviteMessage',
        defaultMessage: 'Are you sure you want to resend the invite to the user?',
    },
    singleRoleAssignmentConstraintMessage: {
        id: 'sts-user-management-ui.singleRoleAssignmentConstraintMessage',
        defaultMessage: 'Access to this application can be currently managed only from Users profile screen.',
    },
    enableUsersConfirmation: {
        id: 'sts-user-management-ui.enableUsersConfirmation',
        defaultMessage:
            'Enabling these users will allow them to perform operations as per their verification status. Are you sure you want to enable these users?',
    },
    enableUsersSuccess: {
        id: 'sts-user-management-ui.enableUsersSuccess',
        defaultMessage: 'User(s) enabled successfully.',
    },
    usersSelected: {
        id: 'sts-user-management-ui.usersSelected',
        defaultMessage: '{usersCount} User(s) Selected',
    },
    enableAccountMessage: {
        id: 'sts-user-management-ui.enableAccountMessage',
        defaultMessage: 'Are you sure you want to enable the user?',
    },
    enableAccountSuccessMessage: {
        id: 'sts-user-management-ui.enableAccountSuccessMessage',
        defaultMessage: 'User account has been enabled successfully.',
    },
    enableUser: {
        id: 'sts-user-management-ui.enableUser',
        defaultMessage: 'Enable User',
    },
    disableUser: {
        id: 'sts-user-management-ui.disableUser',
        defaultMessage: 'Disable User',
    },
    disableUsersSuccess: {
        id: 'sts-user-management-ui.disableUsersSuccess',
        defaultMessage: 'User(s) disabled successfully.',
    },
    updateRole: {
        id: 'sts-user-management-ui.updateRole',
        defaultMessage: 'Update Role',
    },
    disableUserConfirmation: {
        id: 'sts-user-management-ui.disableUserConfirmation',
        defaultMessage:
            'Disabling these users will revoke their access to the connected apps. Are you sure you want to disable these users?',
    },
    disableUsersAccount: {
        id: 'sts-user-management-ui.deleteUsersAccount',
        defaultMessage: "Disable user's account",
    },
    deleteAndRemoveUsersAccount: {
        id: 'sts-user-management-ui.deleteAndRemoveUsersAccount',
        defaultMessage: 'Delete and remove from list',
    },
    resetPasswordTooltipMessage: {
        id: 'sts-user-management-ui.resetPasswordTooltipMessage',
        defaultMessage: 'Reset password is only available when using the local login method.',
    },
    resendInviteTooltipMessage: {
        id: 'sts-user-management-ui.resendInviteTooltipMessage',
        defaultMessage: 'Resend invite is only available when using the local login method.',
    },
    disableUserTooltipMessage: {
        id: 'sts-user-management-ui.disableUserTooltipMessage',
        defaultMessage: 'Disabling account will revoke user access from all the connected applications temporarily.',
    },
    enableUserTooltipMessage: {
        id: 'sts-user-management-ui.enableUserTooltipMessage',
        defaultMessage: 'Enabling account will give user access as per roles defined in connected apps.',
    },
    unassigned: {
        id: 'sts-user-management-ui.unassigned',
        defaultMessage: 'Unassigned',
    },
    noResultsFound: {
        id: 'sts-user-management-ui.noResultsFound',
        defaultMessage: 'No results found.',
    },
    noUserSearchResultsFound: {
        id: 'sts-user-management-ui.noUserSearchResultsFound',
        defaultMessage: 'Sorry, no users found based on your search',
    },
    authenticationOnlyConnectedAppDescription: {
        id: 'sts-user-management-ui.authenticationOnlyConnectedAppDescription',
        defaultMessage:
            'This application does not currently support role assignment. User access is only allowed at this time.',
    },
    authenticationOnlyConnectedAppDescriptionForRoles: {
        id: 'sts-user-management-ui.authenticationOnlyConnectedAppDescriptionForRoles',
        defaultMessage: 'Access to this application can be currently managed only from Users profile screen.',
    },
    userAccessEnabled: {
        id: 'sts-user-management-ui.userAccessEnabled',
        defaultMessage: 'User access enabled',
    },
    userAccessDisabled: {
        id: 'sts-user-management-ui.userAccessDisabled',
        defaultMessage: 'User access disabled',
    },
    noUserAccessControlMessage: {
        id: 'sts-user-management-ui.noUserAccessControlMessage',
        defaultMessage: 'User access to this application is managed within at application end only.',
    },
    allRoles: {
        id: 'sts-user-management-ui.allRoles',
        defaultMessage: 'All Roles',
    },
    allConnectedApps: {
        id: 'sts-user-management-ui.allConnectedApps',
        defaultMessage: 'All Connected Apps',
    },
    allStatuses: {
        id: 'sts-user-management-ui.allStatuses',
        defaultMessage: 'All Statuses',
    },
    allAuthentication: {
        id: 'sts-user-management-ui.allAuthentication',
        defaultMessage: 'All Authentication',
    },
    allMfaProviders: {
        id: 'sts-user-management-ui.allMfaProviders',
        defaultMessage: 'All MFA Providers',
    },
    unableToFetchInstanceDetails: {
        id: 'sts-user-management-ui.unableToFetchInstanceDetails',
        defaultMessage: 'Error: Unable to fetch instance details.',
    },
    customRoleChangedConfirmationMessage: {
        id: 'sts-user-management-ui.customRoleChangedConfirmationMessage',
        defaultMessage:
            'Some of the updated roles were created by overriding default roles. Once they are changed, they cannot be reverted back. Do you wish to continue?',
    },
    export: {
        id: 'sts-user-management-ui.export',
        defaultMessage: 'Export',
    },
    exportUserList: {
        id: 'sts-user-management-ui.exportUserList',
        defaultMessage: 'Export User List',
    },
    exportUser: {
        id: 'sts-user-management-ui.exportUser',
        defaultMessage: 'Export User',
    },
    exportAll: {
        id: 'sts-user-management-ui.exportAll',
        defaultMessage: 'Export All',
    },
    usersCount: {
        id: 'sts-user-management-ui.usersCount',
        defaultMessage: '{usersCount} User(s)',
    },
    selectedUsersWithFilter: {
        id: 'sts-user-management-ui.selectedUsersWithFilter',
        defaultMessage:
            'Continuing with this option will export selected users with the applied filters. Are you sure you want to continue?',
    },
    allUsersWithFilter: {
        id: 'sts-user-management-ui.allUsersWithFilter',
        defaultMessage:
            'Continuing with this option will export all the users from current page with the applied filters. Are you sure you want to continue?',
    },
    selectedUsersWithoutFilter: {
        id: 'sts-user-management-ui.selectedUsersWithoutFilter',
        defaultMessage:
            'Continuing with this option will export the selected users. Are you sure you want to continue?',
    },
    allUsersWithoutFilter: {
        id: 'sts-user-management-ui.allUsersWithoutFilter',
        defaultMessage: 'Continuing with this option will export all the users. Are you sure you want to continue?',
    },
    noOfConnectedApps: {
        id: 'sts-user-management-ui.noOfConnectedApps',
        defaultMessage: '# APPS',
    },
    selectLicense: {
        id: 'sts-user-management-ui.selectLicense',
        defaultMessage: 'Select license',
    },
    selectLicenseType: {
        id: 'sts-user-management-ui.selectLicenseType',
        defaultMessage: 'Select a license type',
    },
    licenseType: {
        id: 'sts-user-management-ui.licenseType',
        defaultMessage: 'License Type',
    },
    emptyFieldsError: {
        id: 'sts-user-management-ui.emptyFieldsError',
        defaultMessage: "Mandatory fields can't be empty",
    },
    noLicenseTypeError: {
        id: 'sts-user-management-ui.noLicenseTypeError',
        defaultMessage: 'No licenses available for the selected option.',
    },
    assign: {
        id: 'sts-user-management-ui.assign',
        defaultMessage: 'Assign',
    },
    assignedUsersToRole: {
        id: 'sts-user-management-ui.assignedUsersToRole',
        defaultMessage: 'Users assignment to the role was successful.',
    },
    confirmationMessageToDeleteRole: {
        id: 'sts-user-management-ui.confirmationMessageToDeleteRole',
        defaultMessage: 'Are you sure you want to cancel? It will delete the created role, please confirm to continue.',
    },
    failedToDeleteIdentityRole: {
        id: 'sts-user-management-ui.failedToDeleteIdentityRole',
        defaultMessage:
            'We couldn’t delete the identity role right now. Please try again or refresh the page if this persists.',
    },
    addRoleSuccessTitle: {
        id: 'sts-user-management-ui.addRoleSuccessTitle',
        defaultMessage: 'Success! Your role has been created',
    },
    addRoleSuccessDesc: {
        id: 'sts-user-management-ui.addRoleSuccessDesc',
        defaultMessage:
            'Create an identity role to define an identity with multiple access levels you want to assign to users ',
    },
    addNewRole: {
        id: 'sts-user-management-ui.addNewRole',
        defaultMessage: 'Create Another Role',
    },
    addAnotherRoleDesc: {
        id: 'sts-user-management-ui.addAnotherRoleDesc',
        defaultMessage: 'Click the button below to create a new Identity role',
    },
    roleAssignUsersSubheader: {
        id: 'sts-user-management-ui.roleAssignUsersSubheader',
        defaultMessage:
            'Add/Remove the users to give/revoke the access to the apps as per defined app roles and resources/sites (if applicable) defined under this role.',
    },
    update: {
        id: 'sts-user-management-ui.update',
        defaultMessage: 'Update',
    },
    stepper_check_mark: {
        id: 'sts-user-management-ui.stepper_check_mark',
        defaultMessage: 'Stepper check mark',
    },
    category: {
        id: 'sts-user-management-ui.category',
        defaultMessage: 'Category',
    },
    duoMfaTooltipMessage: {
        id: 'sts-user-management-ui.duoMfaTooltipMessage',
        defaultMessage:
            'To set up Duo MFA, go to the Authentication tab and select Multi-Factor Authentication. Just make sure it is enabled for user assignments.',
    },
    addExternalIdp: {
        id: 'sts-user-management-ui.addExternalIdp',
        defaultMessage: 'Add Login Provider',
    },
    add2FactorMfa: {
        id: 'sts-user-management-ui.add2FactorMfa',
        defaultMessage: 'Add DUO MFA',
    },
    add2FactorMfaTitle: {
        id: 'sts-user-management-ui.add2FactorMfaTitle',
        defaultMessage: 'Add DUO Multi-Factor Authentication',
    },
    edit2FactorMfa: {
        id: 'sts-user-management-ui.edit2FactorMfa',
        defaultMessage: 'Edit  DUO Multi-Factor Authentication',
    },
    twoFactorMfaInfo: {
        id: 'sts-user-management-ui.twoFactorMfaInfo',
        defaultMessage: 'DUO Multi-Factor Configuration',
    },
    mfaSubTitle: {
        id: 'sts-user-management-ui.mfaSubTitle',
        defaultMessage: 'To keep your account secure, we need you to set up DUO Multi-Factor Authentication.',
    },
    mfaSubHeading: {
        id: 'sts-user-management-ui.mfaSubHeading',
        defaultMessage:
            "To make sure everything works smoothly, it's important that the information you enter is accurate and matches the values you previously set up in Duo Security.",
    },
    secretKey: {
        id: 'sts-user-management-ui.secretKey',
        defaultMessage: 'Secret Key',
    },
    secretKeySubHeading: {
        id: 'sts-user-management-ui.secretKeySubHeading',
        defaultMessage:
            'vLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
    },
    enterSecretKey: {
        id: 'sts-user-management-ui.enterSecretKey',
        defaultMessage: 'Enter Secret Key',
    },
    integrationKey: {
        id: 'sts-user-management-ui.integrationKey',
        defaultMessage: 'Integration Key',
    },
    enterIntegrationKey: {
        id: 'sts-user-management-ui.enterIntegrationKey',
        defaultMessage: 'Enter Integration Key',
    },
    apiHostName: {
        id: 'sts-user-management-ui.apiHostName',
        defaultMessage: 'API Hostname',
    },
    enterApiHostName: {
        id: 'sts-user-management-ui.enterApiHostName',
        defaultMessage: 'Enter API Host Name',
    },
    keySubLabel: {
        id: 'sts-user-management-ui.keySubLabel',
        defaultMessage:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
    },
    authenticationFailedGetMfaProviders: {
        id: 'sts-user-management-ui.authenticationFailedGetMfaProviders',
        defaultMessage:
            'We couldn’t fetch all the external MFA providers right now. Please try again or refresh the page if this persists.',
    },
    failedToActionExternalMfa: {
        id: 'sts-user-management-ui.failedToActionExternalMfa',
        defaultMessage:
            'We couldn’t {action} external MFA provider right now. Please try again or refresh the page if this persists.',
    },
    successActionExternalMfa: {
        id: 'sts-user-management-ui.successActionExternalMfa',
        defaultMessage: 'Mfa provider {action} successfully',
    },
    mfaDeletedSuccessfully: {
        id: 'sts-user-management-ui.mfaDeletedSuccessfully',
        defaultMessage: "You've successfully deleted the DUO Multi-Factor authentication provider",
    },
    failedToDeleteMFA: {
        id: 'sts-user-management-ui.failedToDeleteMFA',
        defaultMessage:
            'We couldn’t delete the external MFA provider right now. Please try again or refresh the page if this persists.',
    },
    failedToGetProviderUsers: {
        id: 'sts-user-management-ui.failedToGetProviderUsers',
        defaultMessage:
            'We couldn’t fetch all the users associated with the provider right now. Please try again or refresh the page if this persists.',
    },
    EmptyStateAuthenticationMessage: {
        id: 'sts-user-management-ui.EmptyStateAuthenticationMessage',
        defaultMessage:
            'Hi! We care about the security of your account, and we\'re here to help you make it even safer! You can add external login providers and external MFAs right here. To get started, just click on "Add provider" and choose the type of provider you want to add. It\'s easy peasy!',
    },
    NoProviderPresent: {
        id: 'sts-user-management-ui.NoProviderPresent',
        defaultMessage: 'No Providers Present',
    },
    duoDisplayName: {
        id: 'sts-user-management-ui.duoDisplayName',
        defaultMessage: 'Set a DUO Provider Name',
    },
    loginProviderDeletionSuccessful: {
        id: 'sts-user-management-ui.loginProviderDeletionSuccessful',
        defaultMessage: "You've successfully deleted the login provider.",
    },
    addUsersIdentityAssignmentFailedHeader: {
        id: 'sts-user-management-ui.addUsersIdentityAssignmentFailedHeader',
        defaultMessage:
            'We couldn’t assign the identity role right now. Please try again or refresh the page if this persists.',
    },

    addUsersIdentityAssignmentFailed: {
        id: 'sts-user-management-ui.addUsersIdentityAssignmentFailed',
        defaultMessage:
            'We encountered an issue when attempting to assign an Identity role {roleName} to this user. However, the rest of the changes you made were saved successfully. Please try assigning the Identity role again',
    },

    identityRolesAssignmentFailedPartialorFull: {
        id: 'sts-user-management-ui.identityRolesAssignmentFailedPartialorFull',
        defaultMessage:
            'We encountered an issue when attempting to assign some Identity role(s) to this user. However, the rest of the changes you made were saved successfully. Please try assigning the Identity role(s) again after checking your access rights and licenses.',
    },

    identityRolesAssignmentFailedServerSide: {
        id: 'sts-user-management-ui.identityRolesAssignmentFailedServerSide',
        defaultMessage:
            'We encountered an issue when attempting to assign Identity role(s) to this user. However, the rest of the changes you made were saved successfully. Please try assigning the Identity role(s) again after some time.',
    },

    usersIdentityAssignmentFailedHeader: {
        id: 'sts-user-management-ui.usersIdentityAssignmentFailedHeader',
        defaultMessage: 'Unable to assign Identity role to this user. Kindly contact the IT support for assistance.',
    },

    usersIdentityAssignmentFailed: {
        id: 'sts-user-management-ui.usersIdentityAssignmentFailed',
        defaultMessage: 'The issue might be due to any of the following reasons:',
    },

    usersIdentityAssignmentFailedFirstReason: {
        id: 'sts-user-management-ui.usersIdentityAssignmentFailedFirstReason',
        defaultMessage: 'You are not authorized to add the selected Identity Role(s).',
    },

    usersIdentityAssignmentFailedSecondReason: {
        id: 'sts-user-management-ui.usersIdentityAssignmentFailedSecondReason',
        defaultMessage: 'There might be some server-level error.',
    },

    addUserAppAssignmentFailedHeader: {
        id: 'sts-user-management-ui.addUserAppAssignmentFailedHeader',
        defaultMessage: 'We couldn’t assign the {appNames} role to this user.',
    },
    addUserAppAssignmentFailed: {
        id: 'sts-user-management-ui.addUserAppAssignmentFailed',
        defaultMessage:
            'The rest of your changes were saved successfully. To complete the role assignment, edit the user’s details and try again.',
    },
    provideAppRole: {
        id: 'sts-user-management-ui.provideAppRole',
        defaultMessage: 'Kindly select app role field to {appNames}',
    },
    appRoleAssignment: {
        id: 'sts-user-management-ui.appRoleAssignment',
        defaultMessage: 'You must select the app role in order to assign this app access to user',
    },
    disabledDuoAssignedError: {
        id: 'sts-user-management-ui.disabledDuoAssignedError',
        defaultMessage:
            "Duo provider for this user is disabled. Choose a new one from the list or enable the assigned one in the Authentication tab. Otherwise, this user can't log in via Duo MFA.",
    },
    licensesCountTextForShared: {
        id: 'sts-user-management-ui.licensesCountTextForShared',
        defaultMessage: '{count} license(s) available for {name}',
    },
    NolicensesTextForShared: {
        id: 'sts-user-management-ui.NolicensesTextForShared',
        defaultMessage: 'No license required',
    },
    applicationRoles: {
        id: 'sts-user-management-ui.applicationRoles',
        defaultMessage: 'Application Roles',
    },
    identityRolesMUI: {
        id: 'sts-user-management-ui.identityRolesMUI',
        defaultMessage: 'Identity Roles V2',
    },
    authenticationNew: {
        id: 'sts-user-management-ui.authenticationNew',
        defaultMessage: 'Authentication V2',
    },
    usersNew: {
        id: 'sts-user-management-ui.usersNew',
        defaultMessage: 'Users V2',
    },
    productsTabV2: {
        id: 'sts-user-management-ui.productsTabV2',
        defaultMessage: 'Products V2',
    },
    subscribersTab: {
        id: 'sts-user-management-ui.productsTabV2',
        defaultMessage: 'Subscriptions',
    },
    clone: {
        id: 'sts-user-management-ui.clone',
        defaultMessage: 'Clone',
    },
    manageIdentityRoles: {
        id: 'sts-user-management-ui.manageIdentityRoles',
        defaultMessage: 'Manage Identity Roles',
    },
    listOfConnectedAppsAndRoles: {
        id: 'sts-user-management-ui.manageApplicationRoles',
        defaultMessage: 'Application Roles',
    },
    asioApplicationRoles: {
        id: 'sts-user-management-ui.manageApplicationRoles',
        defaultMessage: 'Asio Application Roles',
    },
    permissionsView: {
        id: 'sts-user-management-ui.permissionManagement',
        defaultMessage: 'Permissions View',
    },
    NoApplicationRoleSelectedTitle: {
        id: 'sts-user-management-ui.NoApplicationRoleSelectedTitle',
        defaultMessage: 'Select a Connected App to view and customize Application Roles',
    },
    NoApplicationRoleSelectedDescription: {
        id: 'sts-user-management-ui.NoApplicationRoleSelectedDescription',
        defaultMessage:
            'To customize roles for a connected app, first choose the app. Then, select an application role under it and from there, you can customize the roles according to your specific needs.',
    },
    problemFetchingPermissions: {
        id: 'sts-user-management-ui.problemFetchingPermissions',
        defaultMessage:
            'Sorry for any inconvenience, It seems some permissions failed to load. Please refresh the page to ensure correct role access.',
    },
    problemFetchingDomains: {
        id: 'sts-user-management-ui.problemFetchingDomains',
        defaultMessage: GENERIC_ERROR_MESSAGES.GET,
    },
    cloneAsioRole: {
        id: 'sts-user-management-ui.cloneAsioRole',
        defaultMessage: 'Create a custom role from {roleName}',
    },
    assignPermissions: {
        id: 'sts-user-management-ui.assignPermissions',
        defaultMessage: 'Assign Permissions',
    },
    noOfAssignedPermissions: {
        id: 'sts-user-management-ui.noOfAssignedPermissions',
        defaultMessage: '{permissionCount} assigned permission(s)',
    },
    commonAppIdentityRoleErrorMessage: {
        id: 'sts-user-management-ui.commonAppIdentityRoleErrorMessage',
        defaultMessage:
            'This user is assigned a user role for { commonApps } and inherits an additional role from Identity role { identityRoleError }. To continue, you must remove one of these roles for this connected app. You can either edit your Identity role or remove the assigned app role from your account.',
    },
    success: {
        id: 'sts-user-management-ui.success',
        defaultMessage: 'Success',
    },
    addRoleInfo: {
        id: 'sts-user-management-ui.createAppRoleTitle',
        defaultMessage: 'Add Role information',
    },
    editRoleInfo: {
        id: 'sts-user-management-ui.editRoleInfo',
        defaultMessage: 'Edit Role information',
    },
    editRoleInfoDesc: {
        id: 'sts-user-management-ui.editRoleInfoDesc',
        defaultMessage:
            'Edit the Role name and Description for the role that fits the role of the user to which it will be applied',
    },
    createAppRoleSubTitle: {
        id: 'sts-user-management-ui.createAppRoleSubTitle',
        defaultMessage:
            'Now you can create a role from the existing role by cloning it. Start by adding Role name and Description for the desired role.',
    },
    createAppRoleRoleNameInputLabel: {
        id: 'sts-user-management-ui.createAppRoleRoleNameInputLabel',
        defaultMessage: 'Role Name',
    },
    createAppRoleRoleDescriptionInputLabel: {
        id: 'sts-user-management-ui.createAppRoleRoleDescriptionInputLabel',
        defaultMessage: 'Role Description',
    },
    createAppRoleRoleNamePlaceholder: {
        id: 'sts-user-management-ui.createAppRoleRoleNamePlaceholder',
        defaultMessage: 'Input text',
    },
    createAppRoleRoleDescriptionPlaceholder: {
        id: 'sts-user-management-ui.createAppRoleRoleDescriptionPlaceholder',
        defaultMessage: 'Placeholder text',
    },
    createAppRoleRoleNameLengthError: {
        id: 'sts-user-management-ui.createAppRoleRoleNameLengthError',
        defaultMessage: 'The maximum length:',
    },
    createAppRoleRoleNameDuplicateError: {
        id: 'sts-user-management-ui.createAppRoleRoleNameDuplicateError',
        defaultMessage: 'This Role name already exists. Enter a unique role name.',
    },
    createAppRoleRoleNameSpecialCharactersError: {
        id: 'sts-user-management-ui.createAppRoleRoleNameSpecialCharactersError',
        defaultMessage:
            'Oops! It seems you’ve entered an invalid character. Please only use the following special characters: : -',
    },
    createAppRoleRoleNameEmptyError: {
        id: 'sts-user-management-ui.createAppRoleRoleNameEmptyError',
        defaultMessage: 'You must enter Role name to proceed',
    },
    appRoleClonedSuccessfullyTitle: {
        id: 'sts-user-management-ui.appRoleClonedSuccessfullyTitle',
        defaultMessage: 'Congrats! You have successfully created a custom application role named - {roleName}',
    },
    appRoleUpdatedSuccessfully: {
        id: 'sts-user-management-ui.appRoleUpdatedSuccessfully',
        defaultMessage: 'Application role named {roleName} has been updated successfully.',
    },
    appRoleCreatedSuccessfullySubtitle: {
        id: 'sts-user-management-ui.appRoleCreatedSuccessfullySubtitle',
        defaultMessage:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.',
    },
    cloneAppRole: {
        id: 'sts-user-management-ui.cloneAppRole',
        defaultMessage: 'Clone Role',
    },
    appRoleClonedSuccessful: {
        id: 'sts-user-management-ui.appRoleClonedSuccessful',
        defaultMessage: 'Custom Application Role has been created.',
    },
    editAppRole: {
        id: 'sts-user-management-ui.editAppRole',
        defaultMessage: 'Edit {roleName} Role',
    },
    actions: {
        id: 'sts-user-management-ui.actions',
        defaultMessage: 'Actions',
    },
    optInMessageInProgessLine1: {
        id: 'sts-user-management-ui.optInMessageInProgessLine1',
        defaultMessage:
            "Thank you for choosing to opt-in! We're currently processing your request and will have you up and running in no time.",
    },
    optInMessageInProgessLine2: {
        id: 'sts-user-management-ui.optInMessageInProgessLine2',
        defaultMessage: 'We appreciate your patience and look forward to providing you with a seamless experience.',
    },
    optInMessageInProgessLine3: {
        id: 'sts-user-management-ui.optInMessageInProgessLine3',
        defaultMessage:
            "If you have any questions or concerns, please don't hesitate to reach out to our support team.",
    },
    optInMessageNotOptedLine1: {
        id: 'sts-user-management-ui.optInMessageNotOptedLine1',
        defaultMessage: 'Create Custom Roles for Asio platform application',
    },
    optInMessageNotOptedLine2: {
        id: 'sts-user-management-ui.optInMessageNotOptedLine2',
        defaultMessage:
            'Exciting news! You can now create custom roles for the Asio platform on CW Home and grant tailored access and permissions to your users.',
    },
    optInMessageNotOptedActionHandlerText: {
        id: 'sts-user-management-ui.optInMessageNotOptedActionHandlerText',
        defaultMessage: 'Get Started',
    },
    failedPartnerOptInCheck: {
        id: 'sts-user-management-ui.failedPartnerOptInCheck',
        defaultMessage: GENERIC_ERROR_MESSAGES.GET,
    },
    NoRolesSelectedTitle: {
        id: 'sts-user-management-ui.NoRolesSelectedTitle',
        defaultMessage: 'Select Identity Roles to view access and permissions',
    },
    NoRolesSelectedDescription: {
        id: 'sts-user-management-ui.NoRolesSelectedDescription',
        defaultMessage:
            'All roles associated with all configured applications/ Click specific applications to see dedicated roles. Default applications are not editable, but you can create new roles or clone existing to edit granular permissions for application roles.',
    },
    accessManagement: {
        id: 'sts-user-management-ui.accessManagement',
        defaultMessage: 'Access Management',
    },
    licenseNotRequired: {
        id: 'sts-user-management-ui.licenseNotRequired',
        defaultMessage: 'License not required',
    },
    warningDialogTitle: {
        id: 'sts-user-management-ui.warningDialogTitle',
        defaultMessage: 'You have made some changes',
    },
    warningDialogBodyLabel1: {
        id: 'sts-user-management-ui.warningDialogBodyLabel1',
        defaultMessage: 'Would you like to save or discard your changes?',
    },
    warningDialogBodyLabel2: {
        id: 'sts-user-management-ui.warningDialogBodyLabel2',
        defaultMessage:
            "Please note that if you choose to discard, any modifications you've made will be permanently lost.",
    },
    discard: {
        id: 'sts-user-management-ui.discard',
        defaultMessage: 'Discard',
    },
    searchInputPlaceholder: {
        id: 'sts-user-management-ui.searchInputPlaceholder',
        defaultMessage: 'Search',
    },
    submit: {
        id: 'sts-user-management-ui.submit',
        defaultMessage: 'Submit',
    },
    somethingWentWrong: {
        id: 'sts-user-management-ui.somethingWentWrong',
        defaultMessage: 'Something went wrong',
    },
    AddUsersButton: {
        id: 'sts-user-management-ui.AddUsersButton',
        defaultMessage: 'Add',
    },
    mfaProviders: {
        id: 'sts-user-management-ui.mfaProviders',
        defaultMessage: 'MFA Providers',
    },
    addIdPProvider: {
        id: 'sts-user-management-ui.addIdPProvider',
        defaultMessage: 'Add Login Provider',
    },
    addAuthentication: {
        id: 'sts-user-management-ui.addAuthentication',
        defaultMessage: 'Add Authentication',
    },
    failedToRemoveRole: {
        id: 'sts-user-management-ui.failedToRemoveRole',
        defaultMessage: 'Please do not try to remove the Identity Role(s) not assigned to the user.',
    },
    authClientName: {
        id: 'sts-user-management-ui.authClientName',
        defaultMessage: 'Client Name',
    },
    externalIdPTitle: {
        id: 'sts-user-management-ui.externalIdPTitle',
        defaultMessage: 'Login Provider Information',
    },
    duoMfaInfoTitle: {
        id: 'sts-user-management-ui.duoMfaInfoTitle',
        defaultMessage: 'DUO Multi-Factor Identification Details:',
    },
    duoMfaInfoDesc: {
        id: 'sts-user-management-ui.duoMfaInfoDesc',
        defaultMessage:
            'To keep your account secure, we need you to set up DUO Multi-Factor Authentication. Please add the name and description for the DUO MFA provider.',
    },
    typeOfMfaTitle: {
        id: 'sts-user-management-ui.typeOfMfaTitle',
        defaultMessage: 'DUO Multi-Factor Configuration Details:',
    },
    typeOfMfaDesc: {
        id: 'sts-user-management-ui.typeOfMfaDesc',
        defaultMessage:
            "To make sure everything works smoothly, it's important that the information you enter is accurate and matches the values you previously set up in Duo Security.",
    },
    partialFailureMessageBulkRoleRemoval: {
        id: 'sts-user-management-ui.partialFailureMessageBulkRoleRemoval',
        defaultMessage:
            'We have removed the assigned Identity Role(s) successfully. Please do not try to remove the Identity Role(s) not assigned to the user.',
    },
    requiredFieldError: {
        id: 'sts-user-management-ui.requiredFieldError',
        defaultMessage: 'This field is required',
    },
    configureExternalIdP: {
        id: 'sts-user-management-ui.configureExternalIdP',
        defaultMessage: 'Configure Login Provider',
    },
    addMfoTitle: {
        id: 'sts-user-management-ui.addMfoTitle',
        defaultMessage: 'Add DUO Multi-Factor Authentication',
    },
    saveAndNext: {
        id: 'sts-user-management-ui.saveAndNext',
        defaultMessage: 'Save & Next',
    },
    addExternalIdPSuccessLabel: {
        id: 'sts-user-management-ui.addExternalIdPSuccessLabel',
        defaultMessage:
            'This means that you can now use your credentials from the external IdP to access our services securely. This integration enhances your login experience and streamlines authentication processes. \n Thank you for taking the steps to strengthen the security of your account.',
    },
    addDuoMFAPSuccessLabel: {
        id: 'sts-user-management-ui.addDuoMFAPSuccessLabel',
        defaultMessage:
            'This means that you can now use your credentials from the DUO MFA provider to access our services securely. This integration enhances your login experience and streamlines authentication processes. \n Thank you for taking the steps to strengthen the security of your account.',
    },
    addExternalIdPSuccessTitle: {
        id: 'sts-user-management-ui.addExternalIdPSuccessTitle',
        defaultMessage:
            'Congratulations! You have successfully added a new Login Provider for your account & associated user(s) to it.',
    },
    addDuoMFASuccessTitle: {
        id: 'sts-user-management-ui.addDuoMFASuccessTitle',
        defaultMessage:
            'Congratulations! You have successfully configured a DUO Multi-Factor Authentication Provider (DUO MFA) for your account.',
    },
    NotificationBtn: {
        id: 'sts-user-management-ui.notifications',
        defaultMessage: 'Notifications',
    },
    NotificationError: {
        id: 'sts-user-management-ui.NotificationError',
        defaultMessage: 'Notification Error:',
    },
    NotificationErrorMSg: {
        id: 'sts-user-management-ui.NotificationErrorMSg',
        defaultMessage: 'We apologize, but notifications could not load at the moment.Please try again later.',
    },
    NotificationEmpty: {
        id: 'sts-user-management-ui.NotificationEmpty',
        defaultMessage: 'There are no notifications to see here',
    },
    NotificationEmptyMsg: {
        id: 'sts-user-management-ui.NotificationEmptyMsg',
        defaultMessage: 'When you have notifications, you will see them here',
    },
    BulkUserImportBtn: {
        id: 'sts-user-management-ui.BulkUserImportBtn',
        defaultMessage: 'Import bulk users',
    },
    BulkUserImportHeader: {
        id: 'sts-user-management-ui.BulkUserImportHeader',
        defaultMessage: 'Import Users',
    },
    BulkUserImportHeaderSubtext: {
        id: 'sts-user-management-ui.BulkUserImportHeaderSubtext',
        defaultMessage:
            'To import users, please upload your CSV file containing user information. Ensure that names do not contain numerical characters and email formats are correct. Review the mapping, start the import process, and finally, review the imported users in the system.',
    },
    UploadCsvFileLabel: {
        id: 'sts-user-management-ui.UploadCsvFileLabel',
        defaultMessage: 'Upload CSV',
    },
    UploadCsvFileHelperText: {
        id: 'sts-user-management-ui.UploadCsvFileHelperText',
        defaultMessage: 'Only CSV and XML file types are supported.',
    },
    upload: {
        id: 'sts-user-management-ui.upload',
        defaultMessage: 'Upload',
    },
    uploadFile: {
        id: 'sts-user-management-ui.uploadFile',
        defaultMessage: 'Upload File',
    },
    noImportRecordsLine1: {
        id: 'sts-user-management-ui.noImportRecordsLine1',
        defaultMessage: 'To import users from a CSV file, download the template, fill in user details, map ',
    },
    noImportRecordsLine2: {
        id: 'sts-user-management-ui.noImportRecordsLine2',
        defaultMessage: 'columns to attributes, validate names and emails, review, and import users.',
    },
    downloadTemplate: {
        id: 'sts-user-management-ui.downloadTemplate',
        defaultMessage: 'Download CSV Sample Sheet',
    },
    selectAllPermissions: {
        id: 'sts-user-management-ui.selectAllPermissions',
        defaultMessage: 'Select All Permissions',
    },
    deleteCustomRoleConfirmationText: {
        id: 'sts-user-management-ui.deleteCustomRoleConfirmationText',
        defaultMessage: 'Are you sure you want to delete {roleName} role?',
    },
    deleteCustomRoleConfirmationHeader: {
        id: 'sts-user-management-ui.deleteCustomRoleConfirmationHeader',
        defaultMessage: 'Delete Custom Application Role',
    },
    errorDeletingAppRole: {
        id: 'sts-user-management-ui.errorDeletingAppRole',
        defaultMessage: 'Error while deleting app role.',
    },
    usersAssignedToCustomRoleError: {
        id: 'sts-user-management-ui.usersAssignedToCustomRoleError',
        defaultMessage: 'Cannot delete role with assigned users.',
    },
    appRoleDeletedSuccessfully: {
        id: 'sts-user-management-ui.appRoleDeletedSuccessfully',
        defaultMessage: 'Role has been deleted Successfully.',
    },
    authenticationProviderUsersAssigned: {
        id: 'sts-user-management-ui.authenticationProviderUsersAssigned',
        defaultMessage: "You've successfully assigned users to a new Login Provider!",
    },
    addUserTitle: {
        id: 'sts-user-management-ui.addUserTitle',
        defaultMessage: 'Add User Profile Wizard',
    },
    newAddUserHelperText: {
        id: 'sts-user-management-ui.newAddUserHelperText',
        defaultMessage:
            'Add user account details that will be used to login across connected apps. This user will have limited ConnectWise University access until you have set their First Name, Last Name and ConnectWise Login Email.',
    },
    newUserTitle: {
        id: 'sts-user-management-ui.newUserTitle',
        defaultMessage: 'User Profile Details',
    },
    emailTooltipText: {
        id: 'sts-user-management-ui.emailTooltipText',
        defaultMessage: 'Incorrect email address format',
    },
    view: {
        id: 'sts-user-management-ui.view',
        defaultMessage: 'View',
    },
    saveIDP: {
        id: 'sts-user-management-ui.saveIDP',
        defaultMessage: 'Save',
    },
    unknownRemoveUsersOption: {
        id: 'sts-user-management-ui.unknownRemoveUsersOption',
        defaultMessage: 'Unknown remove users option!',
    },
    editAssignedUsersHelperText: {
        id: 'sts-user-management-ui.editAssignedUsersHelperText',
        defaultMessage:
            'You are currently seeing the list of users in a view only mode. In order to edit the users, click on the Edit button.',
    },
    editAssignedUsersAsReadOnlyHelperText: {
        id: 'sts-user-management-ui.editAssignedUsersAsReadOnlyHelperText',
        defaultMessage: 'This is a view-only mode indicating the list of users assigned to the selected role.',
    },
    fullName: {
        id: 'sts-user-management-ui.fullName',
        defaultMessage: 'Full Name:',
    },
    userDetails: {
        id: 'sts-user-management-ui.userDetails',
        defaultMessage: 'User Details:',
    },
    technicalDetails: {
        id: 'sts-user-management-ui.technicalDetails',
        defaultMessage: 'Technical Details:',
    },
    title: {
        id: 'sts-user-management-ui.title',
        defaultMessage: 'Title:',
    },
    notificationDescription: {
        id: 'sts-user-management-ui.notificationDescription',
        defaultMessage: 'Description:',
    },
    emailId: {
        id: 'sts-user-management-ui.emailId',
        defaultMessage: 'Email Id:',
    },
    markAsRead: {
        id: 'sts-user-management-ui.markAsRead',
        defaultMessage: 'Mark as Read',
    },
    markAsUnread: {
        id: 'sts-user-management-ui.markAsUnread',
        defaultMessage: 'Mark as Unread',
    },
    archive: {
        id: 'sts-user-management-ui.archive',
        defaultMessage: 'Archive',
    },
    updated: {
        id: 'sts-user-management-ui.updated',
        defaultMessage: 'updated',
    },
    deleteNotification: {
        id: 'sts-user-management-ui.deleteNotification',
        defaultMessage: 'Delete Notification',
    },
    errorAtLeastOnePermissionRequired: {
        id: 'sts-user-management-ui.errorAtLeastOnePermissionRequired',
        defaultMessage: 'You must select at least one permission to {oparation} this role.',
    },
    updateApplicationRole: {
        id: 'sts-user-management-ui.updateApplicationRole',
        defaultMessage: 'update',
    },
    cloneApplicationRole: {
        id: 'sts-user-management-ui.cloneApplicationRole',
        defaultMessage: 'create',
    },
    failedToEditApplicationRole: {
        id: 'sts-user-management-ui.failedToEditApplicationRole',
        defaultMessage: GENERIC_ERROR_MESSAGES.CREATE_UPDATE_DELETE,
    },
    loginProvider: {
        id: 'sts-user-management-ui.loginProvider',
        defaultMessage: 'Login Provider',
    },
    custom: {
        id: 'sts-user-management-ui.custom',
        defaultMessage: 'Custom',
    },
    default: {
        id: 'sts-user-management-ui.default',
        defaultMessage: 'Default',
    },
    checkDetails: {
        id: 'sts-user-management-ui.checkDetails',
        defaultMessage: 'Check Details',
    },
    haveQuestions: {
        id: 'sts-user-management-ui.haveQuestions',
        defaultMessage: 'Have questions?',
    },
    authCardsEmptyMsg1: {
        id: 'sts-user-management-ui.authCardsEmptyMsg1',
        defaultMessage:
            "Hi! We care about the security of your account, and we're here to help you make it even safer!",
    },
    authCardsEmptyMsg2: {
        id: 'sts-user-management-ui.authCardsEmptyMsg2',
        defaultMessage:
            "You can add external login providers and external MFAs right here. To get started, just click on 'Add provider' and choose the type of provider you want to add.",
    },
    duplicateRolesConfirmationMessageLine1: {
        id: 'sts-user-management-ui.duplicateRolesConfirmationMessageLine1',
        defaultMessage: 'It looks like there are already existing roles with similar permissions:',
    },
    duplicateRolesConfirmationMessageLine2: {
        id: 'sts-user-management-ui.duplicateRolesConfirmationMessageLine2',
        defaultMessage:
            "Would you like to proceed and save this role anyway? If you want to save it, please click on 'Continue', otherwise click on 'Cancel'.",
    },
    createApplicationRole: {
        id: 'sts-user-management-ui.createApplicationRole',
        defaultMessage: 'Clone Application Role',
    },
    editApplicationRole: {
        id: 'sts-user-management-ui.editApplicationRole',
        defaultMessage: 'Edit Application Role',
    },
    searchByRoleNameAndDescription: {
        id: 'sts-user-management-ui.searchByRoleNameAndDescription',
        defaultMessage: 'Search',
    },
    switchToNewAuthTabHelperText: {
        id: 'sts-user-management-ui.switchToNewAuthTabHelperText',
        defaultMessage: 'You can now switch to the new version of the Authentication tab. Try it today!',
    },
    switchToOldAuthTabHelperText: {
        id: 'sts-user-management-ui.switchToOldAuthTabHelperText',
        defaultMessage: 'Prefer the classic UI of the Authentication tab? You can toggle back to the original view.',
    },
    sortDomainsAlphabeticalAscending: {
        id: 'sts-user-management-ui.sortAlphabeticalAscending',
        defaultMessage: 'Alphabetical (a-z)',
    },
    sortDomainsAlphabeticalDescending: {
        id: 'sts-user-management-ui.sortDomainsAlphabeticalDescending',
        defaultMessage: 'Alphabetical (z-a)',
    },
    sortDomainsNumberOfPermissionsAssignedAscending: {
        id: 'sts-user-management-ui.sortDomainsNumberOfPermissionsAssignedAscending',
        defaultMessage: 'Least Permissions assigned',
    },
    sortDomainsNumberOfPermissionsAssignedDescending: {
        id: 'sts-user-management-ui.sortDomainsNumberOfPermissionsAssignedDescending',
        defaultMessage: 'Most Permissions assigned',
    },
    selectSortOption: {
        id: 'sts-user-management-ui.selectSortOption',
        defaultMessage: 'Select sort option',
    },
    sort: {
        id: 'sts-user-management-ui.sort',
        defaultMessage: 'Sort',
    },
    guestUsers: {
        id: 'sts-user-management-ui.guestUsers',
        defaultMessage: 'Guest Users',
    },
    userId: {
        id: 'sts-user-management-ui.userId',
        defaultMessage: 'User Id',
    },
    youDontHavePermissionToViewUsers: {
        id: 'sts-user-management-ui.youDontHavePermissionToViewUsers',
        defaultMessage: `You do not have enough permission(s) to perform the required operation.`,
    },
    setResourcesAccess: {
        id: 'sts-user-management-ui.setResourcesAccess',
        defaultMessage: 'Assign Resource Access',
    },
    setResourcesAccessInfo: {
        id: 'sts-user-management-ui.setResourcesAccessInfo',
        defaultMessage: `To assign resources, click "Assign Resource Access"`,
    },
    assignedResourcesInfo: {
        id: 'sts-user-management-ui.assignedResourcesInfo',
        defaultMessage: `{assignedContainers}{assignedCompaniesLen}{assignedSitesIdsLen}{futureAll} are assigned to this user.`,
    },
    failedGetAllCorpLevelsForPartner: {
        id: 'sts-user-management-ui.failedGetAllCorpLevelsForPartner',
        defaultMessage: 'We couldn’t fetch all the details right now. Please refresh the page and try again.',
    },
    corporateStructure: {
        id: 'sts-user-management-ui.corporateStructure',
        defaultMessage: 'Corporate Structure',
    },
    companies: {
        id: 'sts-user-management-ui.companies',
        defaultMessage: 'Companies',
    },
    companiesCountTooltipText: {
        id: 'sts-user-management-ui.companiesCountTooltipText',
        defaultMessage: 'Number of companies selected',
    },
    sitesCountTooltipText: {
        id: 'sts-user-management-ui.sitesCountTooltipText',
        defaultMessage: `This doesn't include the inherited sites count. You can add more Sites.`,
    },
    sites: {
        id: 'sts-user-management-ui.sites',
        defaultMessage: 'Sites',
    },
    devices: {
        id: 'sts-user-management-ui.devices',
        defaultMessage: 'Devices',
    },
    csInheritedSitesAlertTitle: {
        id: 'sts-user-management-ui.csInheritedSitesAlertTitle',
        defaultMessage: 'Note: The sites inherited by {selectedCompaniesLen} company(ies) are greyed out.',
    },
    csInheritedCompaniesAlertTitle: {
        id: 'sts-user-management-ui.csInheritedCompaniesAlertTitle',
        defaultMessage: 'Note: The companies inherited by selected container are greyed out.',
    },
    csInheritedSitesSelectAllAlertTitle: {
        id: 'sts-user-management-ui.csInheritedSitesSelectAllAlertTitle',
        defaultMessage: 'Note: The sites inherited by all companies are greyed out.',
    },
    csAccessInfoMessage: {
        id: 'sts-user-management-ui.csAccessInfoMessage',
        defaultMessage:
            'You can only view companies and sites that you have access to. Any changes made here will update the assignment for the selected user.',
    },
    csAdminRoleAlertTitle: {
        id: 'sts-user-management-ui.csAdminRoleAlertTitle',
        defaultMessage:
            'As a {adminRoleName}, all companies and sites including newly added are assigned to this user by default. This is a view-only mode, and selection is disabled.',
    },
    csAdminRoleAlertTitleForContainer: {
        id: 'sts-user-management-ui.csAdminRoleAlertTitleForContainer',
        defaultMessage:
            'As a {adminRoleName}, top level container is assigned to this user by default. This is a view-only mode, and selection is disabled.',
    },
    csAdminRoleAlertTitleForContent: {
        id: 'sts-user-management-ui.csAdminRoleAlertTitleForContent',
        defaultMessage:
            'By default, Admin roles have access to all content items. Content access cannot be modified for {adminRoleName} roles.',
    },
    csAllCurrentAndFutureContentAssigned: {
        id: 'sts-user-management-ui.csAllCurrentAndFutureContentAssigned',
        defaultMessage: 'Assign all current and future content items.',
    },
    corporateStructureSubtitle: {
        id: 'sts-user-management-ui.corporateStructureSubtitle',
        defaultMessage:
            'Assigning a resource to a user improves operations,' +
            'strengthens security, and fosters collaboration by clearly defining access and management.',
    },
    corporateStructureEmptyStateHeaderContainerSubtitle: {
        id: 'sts-user-management-ui.corporateStructureEmptyStateHeaderContainerSubtitle',
        defaultMessage: 'Select a Level and the linked companies to assign resources to the user.',
    },
    corporateStructureEmptyStateLevel: {
        id: 'sts-user-management-ui.corporateStructureEmptyState',
        defaultMessage: 'Coming soon!',
    },
    corporateStructureEmptyStateLevelSubtitle: {
        id: 'sts-user-management-ui.corporateStructureEmptyStateLevelSubtitle',
        defaultMessage:
            'We’re excited to introduce the upcoming Corporate Structure page for client management. This new tool is designed to help organize and manage your companies and sites using hierarchies.',
    },
    corporateStructureEmptyStateContainer: {
        id: 'sts-user-management-ui.corporateStructureEmptyStateContainer',
        defaultMessage: 'No Containers Found',
    },
    corporateStructureEmptyStateContainerSubtitle: {
        id: 'sts-user-management-ui.corporateStructureEmptyStateContainerSubtitle',
        defaultMessage: 'Create containers and linked companies to enable corporate structure assignment for users.',
    },
    genericErrorTitle: {
        id: 'sts-user-management-ui.genericErrorTitle',
        defaultMessage: GENERIC_ERROR_MESSAGES.GET,
    },
    genericErrorSubtitle: {
        id: 'sts-user-management-ui.genericErrorSubtitle',
        defaultMessage: 'Sorry, we were unable to get the details. Please check your connection and try again.',
    },
    levelErrorTitle: {
        id: 'sts-user-management-ui.levelErrorTitle',
        defaultMessage: 'Unable to fetch levels.',
    },
    levelErrorSubtitle: {
        id: 'sts-user-management-ui.levelErrorSubtitle',
        defaultMessage: 'Link your containers to levels.',
    },
    containerErrorTitle: {
        id: 'sts-user-management-ui.containerErrorTitle',
        defaultMessage: 'We couldn’t fetch the details. .',
    },
    containerErrorSubtitle: {
        id: 'sts-user-management-ui.containerErrorSubtitle',
        defaultMessage: 'Please refresh your connection and try again.',
    },
    corporateStructureSetupTitle: {
        id: 'sts-user-management-ui.corporateStructureSetupTitle',
        defaultMessage: 'Corporate Structure Setup',
    },
    corporateStructureSetupButton: {
        id: 'sts-user-management-ui.corporateStructureSetupButton',
        defaultMessage: 'Learn More About Corporate Structure',
    },
    companiesEmptyState: {
        id: 'sts-user-management-ui.companiesEmptyState',
        defaultMessage:
            'It looks like there are no companies set up on your account yet. To add companies, follow these steps:',
    },
    companiesEmptyStateSubtitle: {
        id: 'sts-user-management-ui.companiesEmptyStateSubtitle',
        defaultMessage:
            '1. Sign in to the Asio platform. \n 2. In the left navigation menu, select Clients > Companies. \n\n Click the button below to learn more about creating companies on the Asio platform.',
    },
    companiesEmptyStateButton: {
        id: 'sts-user-management-ui.companiesEmptyStateButton',
        defaultMessage: 'Learn About Company and Sites',
    },
    companiesErrorStateTitle: {
        id: 'sts-user-management-ui.companiesErrorStateTitle',
        defaultMessage: 'We encountered an error while fetching the list of companies.',
    },
    genericFetchErrorTitle: {
        id: 'sts-user-management-ui.genericFetchErrorTitle',
        defaultMessage: 'We had trouble fetching details.',
    },
    genericFetchErrorSubTitle: {
        id: 'sts-user-management-ui.genericFetchErrorTitle2',
        defaultMessage: 'Please click the Try Again button below to refresh. ',
    },
    genericFetchErrorSubTitle2: {
        id: 'sts-user-management-ui.genericFetchErrorSubTitle',
        defaultMessage: 'If the problem persists, feel free to contact {link} for assistance.',
    },
    companiesErrorStateCount: {
        id: 'sts-user-management-ui.companiesErrorStateCount',
        defaultMessage: 'Failed to fetch companies count from headers.',
    },
    siteErrorStateCount: {
        id: 'sts-user-management-ui.siteErrorStateCount',
        defaultMessage: 'Failed to fetch sites count from headers.',
    },
    companiesErrorStateSubtitle: {
        id: 'sts-user-management-ui.companiesErrorStateSubtitle',
        defaultMessage:
            'Please click the Refresh button below to try again. \n If the problem persists, feel free to contact Support for assistance.',
    },
    errorStateRefreshButton: {
        id: 'sts-user-management-ui.errorStateRefreshButton',
        defaultMessage: 'Refresh',
    },
    errorStateRetryButton: {
        id: 'sts-user-management-ui.errorStateRetryButton',
        defaultMessage: 'Retry',
    },
    tryAgain: {
        id: 'sts-user-management-ui.tryAgain',
        defaultMessage: 'Try Again',
    },
    sitesEmptyState: {
        id: 'sts-user-management-ui.sitesEmptyState',
        defaultMessage:
            'It looks like there are no sites set up on your account yet. To add sites, follow these steps:\n',
    },
    sitesEmptyStateSubtitle: {
        id: 'sts-user-management-ui.sitesEmptyStateSubtitle',
        defaultMessage:
            '1. Sign in to the Asio platform. \n 2. In the left navigation menu, select Clients > Companies. \n 3. Select a Company and click Add Site. \n\n Click the button below to learn more about creating companies on the ASIO platform.',
    },
    sitesErrorStateTitle: {
        id: 'sts-user-management-ui.sitesErrorStateTitle',
        defaultMessage: 'We encountered an error while fetching the list of sites.',
    },
    sitesErrorStateSubtitle: {
        id: 'sts-user-management-ui.sitesErrorStateSubtitle',
        defaultMessage:
            'Please click the Refresh button below to try again. \n If the problem persists, feel free to contact Support for assistance.',
    },
    csGrantFutureContainersCheckboxLabel: {
        id: 'sts-user-management-ui.csGrantFutureContainersCheckboxLabel',
        defaultMessage: 'Allow future access',
    },
    csGrantFutureSitesCheckboxLabel: {
        id: 'sts-user-management-ui.csGrantFutureSitesCheckboxLabel',
        defaultMessage: 'Allow future access',
    },
    csGrantFutureSitesCheckboxTooltip: {
        id: 'sts-user-management-ui.csGrantFutureSitesCheckboxLabel',
        defaultMessage: 'Grants future access to newly created sites.',
    },
    csGrantFutureCompaniesCheckboxLabel: {
        id: 'sts-user-management-ui.csGrantFutureCompaniesCheckboxLabel',
        defaultMessage: 'Allow future access',
    },
    csGrantFutureCompaniesCheckboxTooltip: {
        id: 'sts-user-management-ui.csGrantFutureCompaniesCheckboxLabel',
        defaultMessage: 'Grants future access to newly created companies.',
    },
    selectAllCompaniesCheckboxLabel: {
        id: 'sts-user-management-ui.selectAllCompaniesCheckboxLabel',
        defaultMessage: 'Select all {totalCount} Companies.',
    },
    selectAllCompaniesCheckboxTooltip: {
        id: 'sts-user-management-ui.selectAllCompaniesCheckboxTooltip',
        defaultMessage: 'Gives access to all existing companies.',
    },
    selectAllCompaniesCheckboxWithInheritedTooltip: {
        id: 'sts-user-management-ui.selectAllCompaniesCheckboxWithInheritedTooltip',
        defaultMessage: 'This options is disabled since selected container has inherited company(ies).',
    },
    futureAllLimitedAccessTooltip: {
        id: 'sts-user-management-ui.futureAllLimitedAccessTooltip',
        defaultMessage: 'This options is disabled since user has limited access.',
    },
    selectAllSitesCheckboxLabel: {
        id: 'sts-user-management-ui.selectAllSitesCheckboxLabel',
        defaultMessage: 'Select all {totalCount} Sites',
    },
    selectAllSitesCheckboxTooltip: {
        id: 'sts-user-management-ui.selectAllSitesCheckboxTooltip',
        defaultMessage: 'Gives access to all existing sites.',
    },
    selectAllSitesCheckboxTooltipDisabled: {
        id: 'sts-user-management-ui.selectAllSitesCheckboxTooltipDisabled',
        defaultMessage:
            'These options are currently disabled. To enable them, please deselect the companies you have chosen in the Company tab.',
    },
    raCompaniesSearchPlaceholder: {
        id: 'sts-user-management-ui.raCompaniesSearchPlaceholder',
        defaultMessage: 'Search Companies',
    },
    raSitesSearchPlaceholder: {
        id: 'sts-user-management-ui.raSitesSearchPlaceholder',
        defaultMessage: 'Search Sites',
    },
    corporateStructureLevelSelect: {
        id: 'sts-user-management-ui.corporateStructureLevelSelect',
        defaultMessage: 'Level',
    },
    corporateStructureContainerSelect: {
        id: 'sts-user-management-ui.corporateStructureContainerSelect',
        defaultMessage: 'Container',
    },
    corporateStructureContainerSelectLabel: {
        id: 'sts-user-management-ui.corporateStructureContainerSelectLabel',
        defaultMessage: 'Select Container',
    },
    corporateStructureLevelSelectLabel: {
        id: 'sts-user-management-ui.corporateStructureLevelSelectLabel',
        defaultMessage: 'Select Level',
    },
    corporateStructureContainerFooterPrevious: {
        id: 'sts-user-management-ui.corporateStructureContainerFooterPrevious',
        defaultMessage: 'Back',
    },
    corporateStructureAssignResources: {
        id: 'sts-user-management-ui.corporateStructureAssignResources',
        defaultMessage: 'Assign Resource Access',
    },
    assignResourceButton: {
        id: 'sts-user-management-ui.assignResourceButton',
        defaultMessage: 'Continue',
    },
    corporateStructureAccessRestricted: {
        id: 'sts-user-management-ui.corporateStructureAccessRestricted',
        defaultMessage:
            'You do not have access to CES resources. To gain access, you must have an Asio role with client management permissions.',
    },
    confirmationDialogContinue: {
        id: 'sts-user-management-ui.confirmationDialogContinue',
        defaultMessage: 'Continue',
    },
    confirmationDialogSkip: {
        id: 'sts-user-management-ui.confirmationDialogSkip',
        defaultMessage: 'Skip',
    },
    confirmationDialogContent: {
        id: 'sts-user-management-ui.confirmationDialogContent',
        defaultMessage:
            'You have previously selected all sites. If you continue, the ‘all sites’ selection will be removed, and you will proceed with the company selection. Alternatively, you can skip this step to retain the ‘all sites’ selection.',
    },
    deselectAllResourcesConfirmationMessage: {
        id: 'sts-user-management-ui.deselectAllResourcesConfirmationMessage',
        defaultMessage:
            'Deselecting this row will uncheck the ‘Select All’ option. Only the {itemType} on the current page will remain selected.',
    },
    deselectAllResourcesParentChbxMessage: {
        id: 'sts-user-management-ui.deselectAllResourcesParentChbxMessage',
        defaultMessage:
            'Deselecting this option will uncheck ‘Select All’ option and remove all selected {itemType} across all pages.',
    },
    corporateStructureAssignResourcesSubtitle: {
        id: 'sts-user-management-ui.corporateStructureAssignResourcesSubtitle',
        defaultMessage:
            'Assigning resources to users defines access and management, improves operations, boosts security, and enhances collaboration.',
    },
    corporateStructureLegendContainers: {
        id: 'sts-user-management-ui.corporateStructureLegendContainers',
        defaultMessage: 'Child Containers',
    },
    corporateStructureLegendCompanies: {
        id: 'sts-user-management-ui.corporateStructureLegendCompanies',
        defaultMessage: 'Child Companies',
    },
    corporateStructureLegendSites: {
        id: 'sts-user-management-ui.corporateStructureLegendSites',
        defaultMessage: 'Child Sites',
    },
    gridNoRecordsFoundMsgLine1: {
        id: 'sts-user-management-ui.gridNoRecordsFoundMsgLine1',
        defaultMessage: 'It appears that there is currently no available data to display.',
    },
    gridNoRecordsFailedMsgLine1: {
        id: 'sts-user-management-ui.gridNoRecordsFailedMsgLine1',
        defaultMessage: 'We couldn’t fetch users right now.  Please refresh the page and try again.',
    },
    gridNoRecordsFoundMsgLine2: {
        id: 'sts-user-management-ui.gridNoRecordsFoundMsgLine2',
        defaultMessage: 'You may want to consider adjusting your filter or search criteria for better results.',
    },
    contentGridSearchPlaceholder: {
        id: 'sts-user-management-ui.contentGridSearchPlaceholder',
        defaultMessage: 'Search by content name or description',
    },
    limitedAccessAlertMessage: {
        id: 'sts-user-management-ui.limitedAccessAlertMessage',
        defaultMessage: 'Deselect the Assign all content checkbox to modify access to content items.',
    },
    unassignFutureItemsModalTitle: {
        id: 'sts-user-management-ui.unassignFutureItemsModalTitle',
        defaultMessage: 'Remove assignment for new items',
    },
    unassignFutureItemsModalContent: {
        id: 'sts-user-management-ui.unassignFutureItemsModalContent',
        defaultMessage: 'You are about to remove the assignment from one or more new items. Do you want to continue?',
    },
    assignResourceSuccessMessage: {
        id: 'sts-user-management-ui.assignResourceSuccessMessage',
        defaultMessage: 'Selection successful. Click Save or Add User to apply selections.',
    },
    assignResourceSubscriberSuccessMessage: {
        id: 'sts-user-management-ui.assignResourceSubscriberSuccessMessage',
        defaultMessage: "Selection successful. Click 'Save' to proceed.",
    },
    editSubscriber: {
        id: 'sts-user-management-ui.editSubscriber',
        defaultMessage: 'Subscription Details',
    },
    subscriberDetailsHeader: {
        id: 'sts-user-management-ui.subscriberDetailsHeader',
        defaultMessage: 'Details',
    },
    subscriberDetailsDescription: {
        id: 'sts-user-management-ui.subscriberDetailsHeader',
        defaultMessage:
            'The Subscriber Profile Details section provides essential information for support. You will have limited University access until First & Last Name, and ConnectWise Login Email are set.',
    },
    subscriberNameLabel: {
        id: 'sts-user-management-ui.subscriberNameLabel',
        defaultMessage: 'Subscription Name',
    },
    providerPartner: {
        id: 'sts-user-management-ui.providerPartner',
        defaultMessage: 'Provider Id',
    },
    connectedAppAccessDescription: {
        id: 'sts-user-management-ui.connectedAppAccessDescription',
        defaultMessage: 'Listed below is ConnectWise application connected to your account.',
    },
    connectwiseAsioConnectedApp: {
        id: 'sts-user-management-ui.connectwiseAsioConnectedApp',
        defaultMessage: 'ConnectWise ASIO®',
    },
    connectwiseAsioConnectedAppDescription: {
        id: 'sts-user-management-ui.connectwiseAsioConnectedAppDescription',
        defaultMessage: 'User access will be set as per selected role.',
    },
    selectRoleSubscription: {
        id: 'sts-user-management-ui.selectRole',
        defaultMessage: 'Select Role',
    },
    addResources: {
        id: 'sts-user-management-ui.addResources',
        defaultMessage: 'Add Resources',
    },
    enableSubscriptionInstance: {
        id: 'sts-user-management-ui.enableSubscriptionInstance',
        defaultMessage: 'Enable Subscription Instance',
    },
    disableSubscriptionInstance: {
        id: 'sts-user-management-ui.disableSubscriptionInstance',
        defaultMessage: 'Disable Subscription Instance',
    },
    disableSubscriptionInstanceConfirmation: {
        id: 'sts-user-management-ui.disableSubscriptionInstanceConfirmation',
        defaultMessage: 'Disable the selected Subscription instance?',
    },
    enableSubscriptionInstanceConfirmation: {
        id: 'sts-user-management-ui.enableSubscriptionInstanceConfirmation',
        defaultMessage: 'Enable the selected Subscription instance?',
    },
    failedToGetRoles: {
        id: 'sts-user-management-ui.failedToGetRoles',
        defaultMessage: 'Failed to get Roles. Please try again',
    },
    failedToUpdateRole: {
        id: 'sts-user-management-ui.failedToGetAssignedRole',
        defaultMessage: 'Failed to update Application role for this subscription. Please try again.',
    },
    selectAppRole: {
        id: 'sts-user-management-ui.selectAppRole',
        defaultMessage: 'Select an Application Role',
    },
    emptyRoleMessageForPermissions: {
        id: 'sts-user-management-ui.emptyRoleMessageForPermissions',
        defaultMessage: 'Select a role to view permissions.',
    },
    emptyRoleMessageForUsers: {
        id: 'sts-user-management-ui.emptyRoleMessageForUsers',
        defaultMessage: 'Select a role to view users.',
    },
    emptyRoleMessageForContents: {
        id: 'sts-user-management-ui.emptyRoleMessageForContents',
        defaultMessage: 'Select a role to view contents.',
    },
    selectAllAndFutureDialogTitle: {
        id: 'sts-user-management-ui.selectAllAndFutureDialogTitle',
        defaultMessage: 'Select All',
    },
    unassignAllAndFutureDialogTitle: {
        id: 'sts-user-management-ui.unassignAllAndFutureDialogTitle',
        defaultMessage: 'Unassign All',
    },
    error: {
        id: 'sts-user-management-ui.error',
        defaultMessage: 'Error',
    },
    templateDownloadSuccessMessage: {
        id: 'sts-user-management-ui.templateDownloadSuccessMessage',
        defaultMessage: 'The CSV Sample Sheet has been successfully downloaded',
    },
    templateDownloadFailureMessage: {
        id: 'sts-user-management-ui.templateDownloadFailureMessage',
        defaultMessage: 'The CSV Sample Sheet could not be downloaded. Please try again.',
    },
    bulkImportFetchUsersFailed: {
        id: 'sts-user-management-ui.bulkImportFetchUsersFailed',
        defaultMessage: 'Failed to Fetch Users. Please try again.',
    },
    bulkImportUpdateUserFailed: {
        id: 'sts-user-management-ui.bulkImportUpdateUserFailed',
        defaultMessage: 'Failed to Update User. Please try again.',
    },
    bulkImportRemoveFileFailed: {
        id: 'sts-user-management-ui.bulkImportUpdateUserFailed',
        defaultMessage: 'Failed to Remove File. Please try again.',
    },
    bulkImportRemoveFileSucess: {
        id: 'sts-user-management-ui.bulkImportUpdateUserFailed',
        defaultMessage: 'Successfully Removed File.',
    },
    bulkImportFetchFilesFailed: {
        id: 'sts-user-management-ui.bulkImportFetchFilesFailed',
        defaultMessage: 'Failed to Fetch Current File.',
    },
    bulkImportUploadFileFailed: {
        id: 'sts-user-management-ui.bulkImportUploadFileFailed',
        defaultMessage: 'Failed to Upload File. Please try again.',
    },
    // Generic alert titles
    warning: {
        id: 'sts-user-management-ui.warning',
        defaultMessage: 'Warning',
    },
    info: {
        id: 'sts-user-management-ui.info',
        defaultMessage: 'Info',
    },
    failedImportUsers: {
        id: 'sts-user-management-ui.failedImportUsers',
        defaultMessage: 'Failed to import users. Please try again.',
    },
    usersImportedSuccessfully: {
        id: 'sts-user-management-ui.usersImportedSuccessfully',
        defaultMessage: 'Users imported successfully',
    },
    selectedUsersImportedSuccessfully: {
        id: 'sts-user-management-ui.selectedUsersImportedSuccessfully',
        defaultMessage: 'Selected users imported successfully',
    },
    allUsersImportedSuccessfully: {
        id: 'sts-user-management-ui.allUsersImportedSuccessfully',
        defaultMessage: 'All users imported successfully',
    },
    importAllUsers: {
        id: 'sts-user-management-ui.importAllUsers',
        defaultMessage: 'Import All Users',
    },
    importSelectedUsers: {
        id: 'sts-user-management-ui.importSelectedUsers',
        defaultMessage: 'Import',
    },
    importAllUsersDialogTitle: {
        id: 'sts-user-management-ui.importAllUsersDialogTitle',
        defaultMessage: 'What do you want to import?',
    },
    importVisibleUsersOption: {
        id: 'sts-user-management-ui.importVisibleUsersOption',
        defaultMessage: 'Import all records on this page (for example: {currentPageRecordsCount} records on this page)',
    },
    importAllUsersOption: {
        id: 'sts-user-management-ui.importAllUsersOption',
        defaultMessage: 'Import all records from the grid (for example: {totalUsersCount} records across all pages)',
    },
    importModalHeaderText: {
        id: 'sts-user-management-ui.importModalHeaderText',
        defaultMessage: 'Choose an option',
    },
    importModalPageSummary: {
        id: 'sts-user-management-ui.importModalPageSummary',
        defaultMessage: 'Note: Only validated records will be imported as users.',
    },
    cloneContentAssignmentTitle: {
        id: 'sts-um-cloneContentAssignmentTitle',
        defaultMessage: 'Assign Contents',
    },
    cloneContentAssignmentDesc: {
        id: 'sts-um-cloneContentAssignmentDesc',
        defaultMessage: 'This will clone content assigned to the selected role.',
    },
    cloneContentAssignmentChockboxLbl: {
        id: 'sts-um-cloneContentAssignmentChockboxLbl',
        defaultMessage: 'Yes',
    },
    clientSecret: {
        id: 'sts-user-management-ui.clientSecrets',
        defaultMessage: 'Client Secret',
    },
    clientSecretsPlaceHolder: {
        id: 'sts-user-management-ui.clientSecretsPlaceHolder',
        defaultMessage: 'Enter client secret',
    },
    failedToUpdateClientSecrets: {
        id: 'sts-user-management-ui.failedToUpdateClientSecrets',
        defaultMessage: 'Failed to update client secrets. But other changes were saved successfully.',
    },
    bulkUserImportModalHeader: {
        id: 'sts-um-bulkUserImportModalHeader',
        defaultMessage: 'CSV File Upload',
    },
    bulkUserImportRemoveFileHeader: {
        id: 'sts-um-bulkUserImportRemoveFileHeader',
        defaultMessage: 'Remove CSV File Confirmation',
    },
    bulkUserImportModalBody1: {
        id: 'sts-um-bulkUserImportModalBody1',
        defaultMessage:
            'You are about to upload a CSV file to import users into the User Management system. This process allows you to efficiently add multiple users at once.',
    },
    bulkUserImportModalHeaderContent: {
        id: 'sts-um-bulkUserImportModalHeaderContent',
        defaultMessage:
            'Are you sure you want to remove the CSV file from the bulk user import process? If you proceed, the current upload will be canceled, and no users will be imported. You will need to restart the import process with a new file if you wish to continue adding users.',
    },
    bulkUserImportModalBody2: {
        id: 'sts-um-bulkUserImportModalBody2',
        defaultMessage:
            'To import users, upload a CSV file containing user details such as name and email. Please note that only one file can be uploaded at a time. Each row should represent a single user, including necessary details such as name, email address, and any other required fields. Ensure your file is accurate before proceeding. ',
    },
    removeFile: {
        id: 'sts-um-removeFile',
        defaultMessage: 'Remove File',
    },
    bulkUserImportRemoveUserHeader: {
        id: 'sts-um-bulkUserImportRemoveUserHeader',
        defaultMessage: 'Remove User Confirmation',
    },
    bulkUserImportRemoveUserContent: {
        id: 'sts-um-bulkUserImportRemoveUserContent',
        defaultMessage: 'Are you sure you want to remove this user from the bulk import? This action cannot be undone.',
    },
    removeUser: {
        id: 'sts-um-removeUser',
        defaultMessage: 'Remove User',
    },
    bulkImportRemoveUserSuccess: {
        id: 'sts-um-bulkImportRemoveUserSuccess',
        defaultMessage: 'User removed successfully from bulk import.',
    },
    bulkImportRemoveUserFailed: {
        id: 'sts-um-bulkImportRemoveUserFailed',
        defaultMessage: 'Failed to remove user. Please try again.',
    },
    selectFile: {
        id: 'sts-um-removeFile',
        defaultMessage: 'Select file name',
    },
    fileName: {
        id: 'sts-um-fileName',
        defaultMessage: 'File name',
    },
    learnHow: {
        id: 'sts-um-learnHow',
        defaultMessage: 'Learn How',
    },
    mayBeLater: {
        id: 'sts-um-mayBeLater',
        defaultMessage: 'Maybe Later',
    },
    thirdPartyCookiesBlockedPopupTitle: {
        id: 'sts-um-thirdPartyCookiesBlockedPopupTitle',
        defaultMessage: 'Third Party Cookies',
    },
    thirdPartyCookiesBlockedPopupMsg: {
        id: 'sts-um-thirdPartyCookiesBlockedPopupMsg',
        defaultMessage:
            'To ensure the best possible experience, please unblock third-party cookies in your browser settings. This will help everything function smoothly!',
    },
});

export default Locale;
